// Arariboia Indigenous Territory Boundary - FULL ACCURACY
// Source: FUNAI GeoServer (Official)
// Area: 413,288.05 hectares
// Boundary points: 3623

export const ARARIBOIA_BOUNDARY_FULL: [number, number][] = [
  [-4.807123, -46.033162],
  [-4.807161, -46.033157],
  [-4.807185, -46.033150],
  [-4.807201, -46.033144],
  [-4.807232, -46.033135],
  [-4.807261, -46.033123],
  [-4.807280, -46.033120],
  [-4.807296, -46.033120],
  [-4.807313, -46.033126],
  [-4.807323, -46.033137],
  [-4.807355, -46.033161],
  [-4.807435, -46.033153],
  [-4.807483, -46.033148],
  [-4.807518, -46.033129],
  [-4.807537, -46.033132],
  [-4.807551, -46.033144],
  [-4.807564, -46.033147],
  [-4.807595, -46.033146],
  [-4.807621, -46.033132],
  [-4.807621, -46.033122],
  [-4.807614, -46.033113],
  [-4.807599, -46.033091],
  [-4.807600, -46.033047],
  [-4.807589, -46.032998],
  [-4.807590, -46.032961],
  [-4.807584, -46.032899],
  [-4.807586, -46.032891],
  [-4.807615, -46.032873],
  [-4.807629, -46.032864],
  [-4.807638, -46.032862],
  [-4.807645, -46.032865],
  [-4.807669, -46.032887],
  [-4.807720, -46.032907],
  [-4.807770, -46.032910],
  [-4.807794, -46.032905],
  [-4.807855, -46.032886],
  [-4.807932, -46.032833],
  [-4.807949, -46.032808],
  [-4.807977, -46.032784],
  [-4.808008, -46.032760],
  [-4.808038, -46.032743],
  [-4.808091, -46.032697],
  [-4.808114, -46.032669],
  [-4.808170, -46.032647],
  [-4.808217, -46.032610],
  [-4.808272, -46.032578],
  [-4.808372, -46.032536],
  [-4.808401, -46.032526],
  [-4.808422, -46.032491],
  [-4.808434, -46.032427],
  [-4.808441, -46.032392],
  [-4.808463, -46.032366],
  [-4.808463, -46.032366],
  [-4.808497, -46.032358],
  [-4.808745, -46.032337],
  [-4.808886, -46.032386],
  [-4.808974, -46.032405],
  [-4.809024, -46.032413],
  [-4.809089, -46.032399],
  [-4.809105, -46.032386],
  [-4.809131, -46.032350],
  [-4.809150, -46.032265],
  [-4.809108, -46.032046],
  [-4.809098, -46.031647],
  [-4.809099, -46.031399],
  [-4.809105, -46.031268],
  [-4.809137, -46.031092],
  [-4.809166, -46.030992],
  [-4.809245, -46.030780],
  [-4.809310, -46.030696],
  [-4.809362, -46.030634],
  [-4.809471, -46.030543],
  [-4.809678, -46.030344],
  [-4.809771, -46.030084],
  [-4.809912, -46.029852],
  [-4.809997, -46.029713],
  [-4.810101, -46.029618],
  [-4.810167, -46.029568],
  [-4.810201, -46.029548],
  [-4.810240, -46.029539],
  [-4.810283, -46.029549],
  [-4.810322, -46.029573],
  [-4.810373, -46.029631],
  [-4.810405, -46.029657],
  [-4.810439, -46.029670],
  [-4.810465, -46.029678],
  [-4.810498, -46.029681],
  [-4.810527, -46.029681],
  [-4.810553, -46.029674],
  [-4.810605, -46.029655],
  [-4.810631, -46.029640],
  [-4.810643, -46.029613],
  [-4.810648, -46.029567],
  [-4.810638, -46.029526],
  [-4.810638, -46.029482],
  [-4.810645, -46.029456],
  [-4.810659, -46.029425],
  [-4.810679, -46.029401],
  [-4.810697, -46.029388],
  [-4.810734, -46.029365],
  [-4.810780, -46.029341],
  [-4.810834, -46.029318],
  [-4.810875, -46.029306],
  [-4.810914, -46.029297],
  [-4.810939, -46.029291],
  [-4.810956, -46.029275],
  [-4.810957, -46.029256],
  [-4.810947, -46.029226],
  [-4.810924, -46.029164],
  [-4.810917, -46.029109],
  [-4.810907, -46.029039],
  [-4.810914, -46.028966],
  [-4.810914, -46.028966],
  [-4.810940, -46.028868],
  [-4.810966, -46.028802],
  [-4.810978, -46.028768],
  [-4.810990, -46.028749],
  [-4.811008, -46.028734],
  [-4.811031, -46.028718],
  [-4.811059, -46.028705],
  [-4.811089, -46.028693],
  [-4.811130, -46.028687],
  [-4.811170, -46.028688],
  [-4.811209, -46.028705],
  [-4.811307, -46.028738],
  [-4.811377, -46.028736],
  [-4.811429, -46.028733],
  [-4.811483, -46.028740],
  [-4.811531, -46.028749],
  [-4.811585, -46.028769],
  [-4.811607, -46.028773],
  [-4.811627, -46.028771],
  [-4.811650, -46.028762],
  [-4.811673, -46.028744],
  [-4.811683, -46.028717],
  [-4.811702, -46.028656],
  [-4.811717, -46.028614],
  [-4.811748, -46.028510],
  [-4.811758, -46.028491],
  [-4.811772, -46.028476],
  [-4.811788, -46.028465],
  [-4.811808, -46.028458],
  [-4.811826, -46.028454],
  [-4.811880, -46.028439],
  [-4.811962, -46.028430],
  [-4.811985, -46.028419],
  [-4.811985, -46.028419],
  [-4.812006, -46.028422],
  [-4.812072, -46.028430],
  [-4.812177, -46.028434],
  [-4.812233, -46.028430],
  [-4.812287, -46.028422],
  [-4.812305, -46.028420],
  [-4.812322, -46.028412],
  [-4.812338, -46.028394],
  [-4.812352, -46.028378],
  [-4.812422, -46.028317],
  [-4.812500, -46.028250],
  [-4.812511, -46.028221],
  [-4.812499, -46.028149],
  [-4.812528, -46.028082],
  [-4.812544, -46.028064],
  [-4.812565, -46.028046],
  [-4.812597, -46.028034],
  [-4.812616, -46.028031],
  [-4.812640, -46.028033],
  [-4.812679, -46.028043],
  [-4.812701, -46.028064],
  [-4.812723, -46.028087],
  [-4.812749, -46.028133],
  [-4.812785, -46.028177],
  [-4.812777, -46.028252],
  [-4.812770, -46.028294],
  [-4.812774, -46.028320],
  [-4.812792, -46.028344],
  [-4.812806, -46.028367],
  [-4.812813, -46.028382],
  [-4.812829, -46.028400],
  [-4.812843, -46.028412],
  [-4.812863, -46.028419],
  [-4.812890, -46.028422],
  [-4.812922, -46.028417],
  [-4.812951, -46.028405],
  [-4.813005, -46.028375],
  [-4.813027, -46.028359],
  [-4.813046, -46.028340],
  [-4.813059, -46.028321],
  [-4.813072, -46.028297],
  [-4.813085, -46.028264],
  [-4.813093, -46.028245],
  [-4.813106, -46.028189],
  [-4.813086, -46.028096],
  [-4.813079, -46.028051],
  [-4.813078, -46.028010],
  [-4.813089, -46.027985],
  [-4.813096, -46.027946],
  [-4.813102, -46.027907],
  [-4.813099, -46.027880],
  [-4.813100, -46.027868],
  [-4.813104, -46.027859],
  [-4.813115, -46.027850],
  [-4.813125, -46.027847],
  [-4.813136, -46.027848],
  [-4.813143, -46.027851],
  [-4.813233, -46.027930],
  [-4.813255, -46.027953],
  [-4.813291, -46.028002],
  [-4.813306, -46.028033],
  [-4.813319, -46.028063],
  [-4.813335, -46.028098],
  [-4.813361, -46.028135],
  [-4.813395, -46.028159],
  [-4.813421, -46.028181],
  [-4.813482, -46.028225],
  [-4.813581, -46.028259],
  [-4.813735, -46.028277],
  [-4.813903, -46.028270],
  [-4.813993, -46.028275],
  [-4.814035, -46.028283],
  [-4.814049, -46.028294],
  [-4.814058, -46.028308],
  [-4.814059, -46.028351],
  [-4.814070, -46.028366],
  [-4.814084, -46.028374],
  [-4.814121, -46.028392],
  [-4.814271, -46.028452],
  [-4.814307, -46.028464],
  [-4.814319, -46.028465],
  [-4.814331, -46.028462],
  [-4.814343, -46.028459],
  [-4.814352, -46.028452],
  [-4.814378, -46.028392],
  [-4.814386, -46.028330],
  [-4.814393, -46.028322],
  [-4.814403, -46.028317],
  [-4.814430, -46.028312],
  [-4.814547, -46.028301],
  [-4.814627, -46.028278],
  [-4.814650, -46.028269],
  [-4.814662, -46.028261],
  [-4.814671, -46.028251],
  [-4.814676, -46.028239],
  [-4.814676, -46.028224],
  [-4.814678, -46.028190],
  [-4.814673, -46.028139],
  [-4.814674, -46.028114],
  [-4.814683, -46.028093],
  [-4.814710, -46.028065],
  [-4.814752, -46.028040],
  [-4.814779, -46.028026],
  [-4.814814, -46.028016],
  [-4.814851, -46.028017],
  [-4.814891, -46.028031],
  [-4.814908, -46.028033],
  [-4.814938, -46.028026],
  [-4.814980, -46.028003],
  [-4.815044, -46.027990],
  [-4.815074, -46.027986],
  [-4.815100, -46.027986],
  [-4.815125, -46.027987],
  [-4.815151, -46.027995],
  [-4.815200, -46.028029],
  [-4.815226, -46.028039],
  [-4.815247, -46.028044],
  [-4.815266, -46.028046],
  [-4.815299, -46.028044],
  [-4.815327, -46.028036],
  [-4.815353, -46.028028],
  [-4.815377, -46.028015],
  [-4.815416, -46.027984],
  [-4.815480, -46.027938],
  [-4.815507, -46.027926],
  [-4.815519, -46.027924],
  [-4.815534, -46.027927],
  [-4.815560, -46.027937],
  [-4.815590, -46.027956],
  [-4.815656, -46.028008],
  [-4.815665, -46.028013],
  [-4.815677, -46.028016],
  [-4.815691, -46.028016],
  [-4.815706, -46.028013],
  [-4.815716, -46.028011],
  [-4.815727, -46.028008],
  [-4.815727, -46.028008],
  [-4.815738, -46.028003],
  [-4.815747, -46.027997],
  [-4.815758, -46.027988],
  [-4.815768, -46.027977],
  [-4.815778, -46.027946],
  [-4.815789, -46.027886],
  [-4.815810, -46.027813],
  [-4.815822, -46.027792],
  [-4.815838, -46.027772],
  [-4.815854, -46.027761],
  [-4.815872, -46.027751],
  [-4.815904, -46.027736],
  [-4.815947, -46.027723],
  [-4.816022, -46.027696],
  [-4.816124, -46.027662],
  [-4.816132, -46.027659],
  [-4.816149, -46.027647],
  [-4.816154, -46.027638],
  [-4.816157, -46.027627],
  [-4.816162, -46.027580],
  [-4.816165, -46.027549],
  [-4.816162, -46.027513],
  [-4.816165, -46.027414],
  [-4.816173, -46.027344],
  [-4.816184, -46.027311],
  [-4.816201, -46.027284],
  [-4.816235, -46.027235],
  [-4.816258, -46.027180],
  [-4.816266, -46.027155],
  [-4.816269, -46.027129],
  [-4.816271, -46.027106],
  [-4.816269, -46.027084],
  [-4.816261, -46.026994],
  [-4.816249, -46.026913],
  [-4.816191, -46.026778],
  [-4.816170, -46.026721],
  [-4.816162, -46.026696],
  [-4.816159, -46.026671],
  [-4.816159, -46.026652],
  [-4.816168, -46.026629],
  [-4.816187, -46.026614],
  [-4.816202, -46.026610],
  [-4.816217, -46.026609],
  [-4.816237, -46.026609],
  [-4.816273, -46.026616],
  [-4.816308, -46.026631],
  [-4.816356, -46.026662],
  [-4.816389, -46.026685],
  [-4.816414, -46.026702],
  [-4.816438, -46.026715],
  [-4.816469, -46.026721],
  [-4.816502, -46.026724],
  [-4.816539, -46.026719],
  [-4.816570, -46.026703],
  [-4.816595, -46.026679],
  [-4.816633, -46.026630],
  [-4.816654, -46.026574],
  [-4.816679, -46.026507],
  [-4.816708, -46.026419],
  [-4.816731, -46.026325],
  [-4.816754, -46.026198],
  [-4.816734, -46.026029],
  [-4.816712, -46.025910],
  [-4.816704, -46.025856],
  [-4.816714, -46.025808],
  [-4.816728, -46.025787],
  [-4.816745, -46.025776],
  [-4.816768, -46.025773],
  [-4.816796, -46.025776],
  [-4.816823, -46.025788],
  [-4.816848, -46.025816],
  [-4.816892, -46.025852],
  [-4.816920, -46.025875],
  [-4.816939, -46.025893],
  [-4.816970, -46.025921],
  [-4.816983, -46.025930],
  [-4.817018, -46.025962],
  [-4.817031, -46.025987],
  [-4.817092, -46.026059],
  [-4.817105, -46.026068],
  [-4.817122, -46.026076],
  [-4.817152, -46.026080],
  [-4.817177, -46.026074],
  [-4.817221, -46.026050],
  [-4.817230, -46.026029],
  [-4.817239, -46.026020],
  [-4.817251, -46.026019],
  [-4.817263, -46.026021],
  [-4.817275, -46.026027],
  [-4.817286, -46.026035],
  [-4.817291, -46.026047],
  [-4.817300, -46.026059],
  [-4.817303, -46.026075],
  [-4.817304, -46.026090],
  [-4.817295, -46.026112],
  [-4.817283, -46.026116],
  [-4.817265, -46.026120],
  [-4.817261, -46.026124],
  [-4.817260, -46.026130],
  [-4.817261, -46.026137],
  [-4.817265, -46.026144],
  [-4.817335, -46.026174],
  [-4.817410, -46.026175],
  [-4.817467, -46.026167],
  [-4.817506, -46.026164],
  [-4.817545, -46.026164],
  [-4.817586, -46.026177],
  [-4.817654, -46.026227],
  [-4.817682, -46.026261],
  [-4.817714, -46.026278],
  [-4.817749, -46.026292],
  [-4.817789, -46.026331],
  [-4.817853, -46.026410],
  [-4.817880, -46.026453],
  [-4.817919, -46.026498],
  [-4.817963, -46.026541],
  [-4.818030, -46.026568],
  [-4.818074, -46.026572],
  [-4.818116, -46.026557],
  [-4.818199, -46.026501],
  [-4.818245, -46.026466],
  [-4.818277, -46.026422],
  [-4.818328, -46.026322],
  [-4.818352, -46.026239],
  [-4.818344, -46.026161],
  [-4.818344, -46.026150],
  [-4.818356, -46.026131],
  [-4.818367, -46.026124],
  [-4.818381, -46.026120],
  [-4.818390, -46.026117],
  [-4.818426, -46.026110],
  [-4.818439, -46.026112],
  [-4.818451, -46.026119],
  [-4.818465, -46.026140],
  [-4.818490, -46.026168],
  [-4.818499, -46.026175],
  [-4.818509, -46.026179],
  [-4.818521, -46.026181],
  [-4.818534, -46.026181],
  [-4.818549, -46.026181],
  [-4.818563, -46.026178],
  [-4.818583, -46.026169],
  [-4.818594, -46.026160],
  [-4.818602, -46.026138],
  [-4.818604, -46.026116],
  [-4.818599, -46.026044],
  [-4.818620, -46.026012],
  [-4.818641, -46.025997],
  [-4.818667, -46.025985],
  [-4.818701, -46.025977],
  [-4.818756, -46.025975],
  [-4.818813, -46.025975],
  [-4.818883, -46.025992],
  [-4.818969, -46.026032],
  [-4.819019, -46.026069],
  [-4.819029, -46.026073],
  [-4.819044, -46.026072],
  [-4.819065, -46.026065],
  [-4.819084, -46.026055],
  [-4.819094, -46.026042],
  [-4.819109, -46.026017],
  [-4.819118, -46.025993],
  [-4.819156, -46.025958],
  [-4.819161, -46.025942],
  [-4.819162, -46.025929],
  [-4.819156, -46.025918],
  [-4.819121, -46.025869],
  [-4.819074, -46.025845],
  [-4.819053, -46.025813],
  [-4.819029, -46.025731],
  [-4.819038, -46.025693],
  [-4.819075, -46.025646],
  [-4.819101, -46.025629],
  [-4.819119, -46.025624],
  [-4.819144, -46.025622],
  [-4.819171, -46.025622],
  [-4.819186, -46.025624],
  [-4.819200, -46.025632],
  [-4.819205, -46.025656],
  [-4.819211, -46.025662],
  [-4.819225, -46.025665],
  [-4.819257, -46.025663],
  [-4.819275, -46.025658],
  [-4.819303, -46.025644],
  [-4.819316, -46.025639],
  [-4.819364, -46.025637],
  [-4.819379, -46.025637],
  [-4.819394, -46.025641],
  [-4.819432, -46.025667],
  [-4.819456, -46.025682],
  [-4.819483, -46.025703],
  [-4.819758, -46.025907],
  [-4.819790, -46.025976],
  [-4.819795, -46.026000],
  [-4.819808, -46.026013],
  [-4.819825, -46.026021],
  [-4.819979, -46.026024],
  [-4.819998, -46.026028],
  [-4.820011, -46.026042],
  [-4.820072, -46.026130],
  [-4.820229, -46.026435],
  [-4.820292, -46.026583],
  [-4.820331, -46.026760],
  [-4.820469, -46.027015],
  [-4.820481, -46.027024],
  [-4.820498, -46.027028],
  [-4.820520, -46.027029],
  [-4.820541, -46.027021],
  [-4.820560, -46.027005],
  [-4.820564, -46.026971],
  [-4.820582, -46.026964],
  [-4.820598, -46.026961],
  [-4.820622, -46.026960],
  [-4.820646, -46.026967],
  [-4.820667, -46.026977],
  [-4.820701, -46.027004],
  [-4.820757, -46.027065],
  [-4.820770, -46.027080],
  [-4.820781, -46.027104],
  [-4.820781, -46.027150],
  [-4.820791, -46.027230],
  [-4.820825, -46.027267],
  [-4.820851, -46.027311],
  [-4.820854, -46.027347],
  [-4.820858, -46.027370],
  [-4.820872, -46.027391],
  [-4.820887, -46.027402],
  [-4.820903, -46.027411],
  [-4.820929, -46.027413],
  [-4.820960, -46.027414],
  [-4.820982, -46.027406],
  [-4.821002, -46.027394],
  [-4.821023, -46.027379],
  [-4.821035, -46.027361],
  [-4.821043, -46.027347],
  [-4.821046, -46.027330],
  [-4.821046, -46.027297],
  [-4.821043, -46.027284],
  [-4.821030, -46.027262],
  [-4.821017, -46.027243],
  [-4.821001, -46.027218],
  [-4.820996, -46.027200],
  [-4.820995, -46.027183],
  [-4.820995, -46.027171],
  [-4.821008, -46.027154],
  [-4.821017, -46.027149],
  [-4.821067, -46.027128],
  [-4.821089, -46.027120],
  [-4.821118, -46.027110],
  [-4.821135, -46.027101],
  [-4.821148, -46.027087],
  [-4.821154, -46.027068],
  [-4.821154, -46.027049],
  [-4.821153, -46.027002],
  [-4.821159, -46.026935],
  [-4.821170, -46.026916],
  [-4.821182, -46.026899],
  [-4.821198, -46.026885],
  [-4.821221, -46.026872],
  [-4.821280, -46.026869],
  [-4.821294, -46.026862],
  [-4.821315, -46.026831],
  [-4.821346, -46.026815],
  [-4.821421, -46.026795],
  [-4.821493, -46.026782],
  [-4.821537, -46.026770],
  [-4.821605, -46.026762],
  [-4.821668, -46.026759],
  [-4.821728, -46.026767],
  [-4.821791, -46.026762],
  [-4.821838, -46.026755],
  [-4.821861, -46.026746],
  [-4.821881, -46.026729],
  [-4.821894, -46.026719],
  [-4.821901, -46.026702],
  [-4.821905, -46.026639],
  [-4.821922, -46.026607],
  [-4.821931, -46.026573],
  [-4.821944, -46.026556],
  [-4.821987, -46.026530],
  [-4.822010, -46.026516],
  [-4.822021, -46.026512],
  [-4.822034, -46.026512],
  [-4.822072, -46.026524],
  [-4.822093, -46.026527],
  [-4.822114, -46.026522],
  [-4.822259, -46.026450],
  [-4.822298, -46.026430],
  [-4.822318, -46.026414],
  [-4.822352, -46.026397],
  [-4.822368, -46.026392],
  [-4.822436, -46.026390],
  [-4.822563, -46.026408],
  [-4.822683, -46.026461],
  [-4.822696, -46.026461],
  [-4.822702, -46.026458],
  [-4.822709, -46.026443],
  [-4.822732, -46.026404],
  [-4.822737, -46.026381],
  [-4.822746, -46.026372],
  [-4.822763, -46.026359],
  [-4.822783, -46.026355],
  [-4.822822, -46.026357],
  [-4.822828, -46.026356],
  [-4.822836, -46.026347],
  [-4.822838, -46.026337],
  [-4.822829, -46.026301],
  [-4.822831, -46.026268],
  [-4.822834, -46.026260],
  [-4.822835, -46.026256],
  [-4.822840, -46.026253],
  [-4.822855, -46.026249],
  [-4.822872, -46.026248],
  [-4.822892, -46.026239],
  [-4.822910, -46.026220],
  [-4.822938, -46.026187],
  [-4.822953, -46.026142],
  [-4.822962, -46.026102],
  [-4.822979, -46.026085],
  [-4.823029, -46.026066],
  [-4.823201, -46.026042],
  [-4.823216, -46.026032],
  [-4.823222, -46.026019],
  [-4.823229, -46.025989],
  [-4.823235, -46.025949],
  [-4.823240, -46.025899],
  [-4.823265, -46.025852],
  [-4.823292, -46.025827],
  [-4.823319, -46.025809],
  [-4.823352, -46.025803],
  [-4.823408, -46.025796],
  [-4.823461, -46.025796],
  [-4.823593, -46.025861],
  [-4.823672, -46.025903],
  [-4.823815, -46.025994],
  [-4.823833, -46.026006],
  [-4.823858, -46.026017],
  [-4.823896, -46.026025],
  [-4.823908, -46.026036],
  [-4.823928, -46.026041],
  [-4.823946, -46.026043],
  [-4.823964, -46.026037],
  [-4.824074, -46.025988],
  [-4.824125, -46.025979],
  [-4.824164, -46.025954],
  [-4.824191, -46.025939],
  [-4.824234, -46.025930],
  [-4.824281, -46.025943],
  [-4.824296, -46.025942],
  [-4.824309, -46.025940],
  [-4.824318, -46.025933],
  [-4.824325, -46.025920],
  [-4.824327, -46.025907],
  [-4.824344, -46.025890],
  [-4.824357, -46.025890],
  [-4.824380, -46.025886],
  [-4.824393, -46.025890],
  [-4.824421, -46.025889],
  [-4.824491, -46.025940],
  [-4.824580, -46.025988],
  [-4.824595, -46.026020],
  [-4.824597, -46.026055],
  [-4.824691, -46.026143],
  [-4.824761, -46.026187],
  [-4.824805, -46.026237],
  [-4.824913, -46.026343],
  [-4.824956, -46.026372],
  [-4.824974, -46.026382],
  [-4.824994, -46.026395],
  [-4.825008, -46.026409],
  [-4.825008, -46.026428],
  [-4.825005, -46.026442],
  [-4.824956, -46.026475],
  [-4.824900, -46.026518],
  [-4.824876, -46.026554],
  [-4.824877, -46.026571],
  [-4.824885, -46.026586],
  [-4.824898, -46.026600],
  [-4.824920, -46.026608],
  [-4.824965, -46.026607],
  [-4.825001, -46.026602],
  [-4.825018, -46.026599],
  [-4.825028, -46.026603],
  [-4.825034, -46.026611],
  [-4.825029, -46.026638],
  [-4.825017, -46.026659],
  [-4.824997, -46.026690],
  [-4.824997, -46.026704],
  [-4.825002, -46.026716],
  [-4.825010, -46.026726],
  [-4.825022, -46.026735],
  [-4.825033, -46.026745],
  [-4.825051, -46.026744],
  [-4.825068, -46.026758],
  [-4.825081, -46.026784],
  [-4.825106, -46.026886],
  [-4.825119, -46.026935],
  [-4.825151, -46.026967],
  [-4.825176, -46.026997],
  [-4.825189, -46.027036],
  [-4.825231, -46.027109],
  [-4.825259, -46.027132],
  [-4.825288, -46.027145],
  [-4.825313, -46.027146],
  [-4.825340, -46.027143],
  [-4.825397, -46.027115],
  [-4.825420, -46.027095],
  [-4.825451, -46.027043],
  [-4.825452, -46.027002],
  [-4.825462, -46.026984],
  [-4.825474, -46.026979],
  [-4.825490, -46.026979],
  [-4.825505, -46.026983],
  [-4.825519, -46.026992],
  [-4.825562, -46.027082],
  [-4.825605, -46.027129],
  [-4.825653, -46.027228],
  [-4.825706, -46.027258],
  [-4.825719, -46.027300],
  [-4.825731, -46.027319],
  [-4.825752, -46.027334],
  [-4.825786, -46.027362],
  [-4.825822, -46.027368],
  [-4.825854, -46.027362],
  [-4.825874, -46.027337],
  [-4.825874, -46.027284],
  [-4.825863, -46.027243],
  [-4.825838, -46.027215],
  [-4.825827, -46.027181],
  [-4.825820, -46.027131],
  [-4.825833, -46.027088],
  [-4.825869, -46.027053],
  [-4.825898, -46.027035],
  [-4.825924, -46.027033],
  [-4.825949, -46.027033],
  [-4.825972, -46.027038],
  [-4.826009, -46.027059],
  [-4.826027, -46.027085],
  [-4.826059, -46.027110],
  [-4.826102, -46.027123],
  [-4.826149, -46.027126],
  [-4.826203, -46.027115],
  [-4.826274, -46.027098],
  [-4.826377, -46.027050],
  [-4.826428, -46.027020],
  [-4.826652, -46.026882],
  [-4.826691, -46.026835],
  [-4.826735, -46.026765],
  [-4.826995, -46.026698],
  [-4.827272, -46.026656],
  [-4.827721, -46.026587],
  [-4.827994, -46.026421],
  [-4.828313, -46.026392],
  [-4.828386, -46.026368],
  [-4.828590, -46.026247],
  [-4.828689, -46.026120],
  [-4.828761, -46.025987],
  [-4.828749, -46.025928],
  [-4.828713, -46.025847],
  [-4.828736, -46.025767],
  [-4.828909, -46.025779],
  [-4.829066, -46.025808],
  [-4.829176, -46.025819],
  [-4.829273, -46.025837],
  [-4.829371, -46.025881],
  [-4.829418, -46.025935],
  [-4.829511, -46.025987],
  [-4.829581, -46.026042],
  [-4.829673, -46.025983],
  [-4.829787, -46.025971],
  [-4.829893, -46.025984],
  [-4.830007, -46.026020],
  [-4.830081, -46.026064],
  [-4.830120, -46.026129],
  [-4.830127, -46.026230],
  [-4.830196, -46.026325],
  [-4.830341, -46.026356],
  [-4.830456, -46.026362],
  [-4.830486, -46.026372],
  [-4.830643, -46.026486],
  [-4.830834, -46.026579],
  [-4.830949, -46.026579],
  [-4.831021, -46.026537],
  [-4.831026, -46.026491],
  [-4.831003, -46.026357],
  [-4.831013, -46.026335],
  [-4.831218, -46.026329],
  [-4.831322, -46.026309],
  [-4.831540, -46.026257],
  [-4.831718, -46.026301],
  [-4.831757, -46.026363],
  [-4.831777, -46.026382],
  [-4.831844, -46.026396],
  [-4.831949, -46.026379],
  [-4.832037, -46.026382],
  [-4.832055, -46.026412],
  [-4.832037, -46.026470],
  [-4.832044, -46.026499],
  [-4.832116, -46.026553],
  [-4.832145, -46.026568],
  [-4.832177, -46.026587],
  [-4.832223, -46.026594],
  [-4.832297, -46.026581],
  [-4.832418, -46.026532],
  [-4.832603, -46.026441],
  [-4.832662, -46.026434],
  [-4.832737, -46.026444],
  [-4.832922, -46.026493],
  [-4.833007, -46.026499],
  [-4.833118, -46.026490],
  [-4.833200, -46.026490],
  [-4.833456, -46.026539],
  [-4.833598, -46.026572],
  [-4.833635, -46.026566],
  [-4.833676, -46.026561],
  [-4.833865, -46.026556],
  [-4.834083, -46.026427],
  [-4.834102, -46.026420],
  [-4.834142, -46.026422],
  [-4.834185, -46.026440],
  [-4.834205, -46.026458],
  [-4.834227, -46.026500],
  [-4.834250, -46.026556],
  [-4.834261, -46.026577],
  [-4.834260, -46.026631],
  [-4.834271, -46.026689],
  [-4.834281, -46.026723],
  [-4.834295, -46.026761],
  [-4.834314, -46.026765],
  [-4.834338, -46.026772],
  [-4.834413, -46.026768],
  [-4.834471, -46.026759],
  [-4.834531, -46.026754],
  [-4.834598, -46.026764],
  [-4.834657, -46.026790],
  [-4.834690, -46.026816],
  [-4.834722, -46.026852],
  [-4.834753, -46.026865],
  [-4.834789, -46.026866],
  [-4.834838, -46.026863],
  [-4.834922, -46.026835],
  [-4.835104, -46.026774],
  [-4.835119, -46.026763],
  [-4.835144, -46.026738],
  [-4.835173, -46.026713],
  [-4.835196, -46.026696],
  [-4.835213, -46.026679],
  [-4.835290, -46.026645],
  [-4.835322, -46.026639],
  [-4.835355, -46.026640],
  [-4.835417, -46.026656],
  [-4.835462, -46.026671],
  [-4.835506, -46.026704],
  [-4.835538, -46.026719],
  [-4.835555, -46.026724],
  [-4.835574, -46.026728],
  [-4.835591, -46.026729],
  [-4.835628, -46.026727],
  [-4.835647, -46.026722],
  [-4.835733, -46.026695],
  [-4.835786, -46.026668],
  [-4.835825, -46.026646],
  [-4.835859, -46.026629],
  [-4.835895, -46.026611],
  [-4.835909, -46.026601],
  [-4.835920, -46.026588],
  [-4.835934, -46.026568],
  [-4.835937, -46.026557],
  [-4.835929, -46.026481],
  [-4.835890, -46.026406],
  [-4.835887, -46.026372],
  [-4.835889, -46.026338],
  [-4.835894, -46.026310],
  [-4.835902, -46.026282],
  [-4.835913, -46.026264],
  [-4.835925, -46.026250],
  [-4.835962, -46.026224],
  [-4.836025, -46.026185],
  [-4.836077, -46.026091],
  [-4.836119, -46.025992],
  [-4.836200, -46.025913],
  [-4.836224, -46.025878],
  [-4.836230, -46.025840],
  [-4.836228, -46.025804],
  [-4.836195, -46.025758],
  [-4.836207, -46.025695],
  [-4.836183, -46.025605],
  [-4.836178, -46.025579],
  [-4.836182, -46.025553],
  [-4.836193, -46.025530],
  [-4.836208, -46.025511],
  [-4.836265, -46.025471],
  [-4.836362, -46.025405],
  [-4.836389, -46.025378],
  [-4.836428, -46.025371],
  [-4.836464, -46.025378],
  [-4.836493, -46.025396],
  [-4.836597, -46.025501],
  [-4.836615, -46.025513],
  [-4.836620, -46.025525],
  [-4.836620, -46.025536],
  [-4.836618, -46.025546],
  [-4.836609, -46.025552],
  [-4.836521, -46.025578],
  [-4.836516, -46.025599],
  [-4.836527, -46.025690],
  [-4.836533, -46.025757],
  [-4.836559, -46.025823],
  [-4.836593, -46.025854],
  [-4.836637, -46.025882],
  [-4.836683, -46.025897],
  [-4.836727, -46.025900],
  [-4.836759, -46.025885],
  [-4.836776, -46.025862],
  [-4.836792, -46.025810],
  [-4.836808, -46.025776],
  [-4.836829, -46.025760],
  [-4.836894, -46.025756],
  [-4.836929, -46.025763],
  [-4.836956, -46.025770],
  [-4.836981, -46.025765],
  [-4.836991, -46.025755],
  [-4.836994, -46.025740],
  [-4.836987, -46.025711],
  [-4.836991, -46.025627],
  [-4.836951, -46.025506],
  [-4.836856, -46.025326],
  [-4.836811, -46.025225],
  [-4.836796, -46.025139],
  [-4.836802, -46.025100],
  [-4.836816, -46.025085],
  [-4.836832, -46.025075],
  [-4.836859, -46.025078],
  [-4.836892, -46.025095],
  [-4.836954, -46.025130],
  [-4.837022, -46.025186],
  [-4.837073, -46.025262],
  [-4.837086, -46.025324],
  [-4.837115, -46.025375],
  [-4.837139, -46.025392],
  [-4.837214, -46.025394],
  [-4.837250, -46.025383],
  [-4.837294, -46.025352],
  [-4.837325, -46.025327],
  [-4.837343, -46.025298],
  [-4.837352, -46.025270],
  [-4.837346, -46.025236],
  [-4.837292, -46.025150],
  [-4.837268, -46.025083],
  [-4.837180, -46.024683],
  [-4.837133, -46.024668],
  [-4.837047, -46.024636],
  [-4.836939, -46.024613],
  [-4.836908, -46.024592],
  [-4.836881, -46.024559],
  [-4.836866, -46.024532],
  [-4.836853, -46.024477],
  [-4.836871, -46.024450],
  [-4.836882, -46.024434],
  [-4.836901, -46.024420],
  [-4.836978, -46.024401],
  [-4.837037, -46.024393],
  [-4.837125, -46.024349],
  [-4.837298, -46.024317],
  [-4.837399, -46.024257],
  [-4.837427, -46.024232],
  [-4.837444, -46.024208],
  [-4.837457, -46.024146],
  [-4.837457, -46.024120],
  [-4.837404, -46.024084],
  [-4.837389, -46.024063],
  [-4.837386, -46.024037],
  [-4.837396, -46.024019],
  [-4.837464, -46.023970],
  [-4.837571, -46.023804],
  [-4.837643, -46.023772],
  [-4.837842, -46.023771],
  [-4.838048, -46.023799],
  [-4.838108, -46.023825],
  [-4.838131, -46.023840],
  [-4.838162, -46.023851],
  [-4.838173, -46.023853],
  [-4.838203, -46.023842],
  [-4.838240, -46.023801],
  [-4.838243, -46.023777],
  [-4.838234, -46.023728],
  [-4.838204, -46.023659],
  [-4.838192, -46.023607],
  [-4.838191, -46.023584],
  [-4.838195, -46.023545],
  [-4.838199, -46.023531],
  [-4.838227, -46.023515],
  [-4.838305, -46.023463],
  [-4.838328, -46.023446],
  [-4.838359, -46.023440],
  [-4.838387, -46.023430],
  [-4.838414, -46.023437],
  [-4.838471, -46.023456],
  [-4.838610, -46.023523],
  [-4.838622, -46.023528],
  [-4.838641, -46.023528],
  [-4.838659, -46.023521],
  [-4.838669, -46.023515],
  [-4.838763, -46.023411],
  [-4.838823, -46.023378],
  [-4.838856, -46.023362],
  [-4.838897, -46.023369],
  [-4.838975, -46.023398],
  [-4.839382, -46.023555],
  [-4.839437, -46.023555],
  [-4.839512, -46.023545],
  [-4.839577, -46.023519],
  [-4.839622, -46.023480],
  [-4.839649, -46.023408],
  [-4.839669, -46.023321],
  [-4.839666, -46.023230],
  [-4.839443, -46.022728],
  [-4.839435, -46.022608],
  [-4.839455, -46.022507],
  [-4.839453, -46.022473],
  [-4.839433, -46.022450],
  [-4.839390, -46.022398],
  [-4.839377, -46.022365],
  [-4.839380, -46.022332],
  [-4.839393, -46.022300],
  [-4.839416, -46.022271],
  [-4.839427, -46.022243],
  [-4.839453, -46.022235],
  [-4.839484, -46.022233],
  [-4.839509, -46.022236],
  [-4.839548, -46.022262],
  [-4.839579, -46.022283],
  [-4.839585, -46.022316],
  [-4.839585, -46.022352],
  [-4.839566, -46.022389],
  [-4.839564, -46.022424],
  [-4.839580, -46.022454],
  [-4.839587, -46.022474],
  [-4.839609, -46.022489],
  [-4.839637, -46.022510],
  [-4.839668, -46.022518],
  [-4.839705, -46.022511],
  [-4.839759, -46.022458],
  [-4.839793, -46.022402],
  [-4.839805, -46.022363],
  [-4.839808, -46.022331],
  [-4.839801, -46.022305],
  [-4.839784, -46.022285],
  [-4.839723, -46.022240],
  [-4.839621, -46.022123],
  [-4.839611, -46.022088],
  [-4.839616, -46.022062],
  [-4.839640, -46.022025],
  [-4.839665, -46.022015],
  [-4.839702, -46.022007],
  [-4.839735, -46.022007],
  [-4.839779, -46.022009],
  [-4.839832, -46.022015],
  [-4.839875, -46.022023],
  [-4.839919, -46.022043],
  [-4.839956, -46.022071],
  [-4.839998, -46.022092],
  [-4.840031, -46.022070],
  [-4.840055, -46.022049],
  [-4.840092, -46.022033],
  [-4.840190, -46.022005],
  [-4.840288, -46.021977],
  [-4.840342, -46.021933],
  [-4.840344, -46.021886],
  [-4.840307, -46.021832],
  [-4.840092, -46.021671],
  [-4.840050, -46.021587],
  [-4.840045, -46.021548],
  [-4.840065, -46.021499],
  [-4.840114, -46.021447],
  [-4.840114, -46.021447],
  [-4.840419, -46.021323],
  [-4.840674, -46.020995],
  [-4.840722, -46.020972],
  [-4.840786, -46.020976],
  [-4.840919, -46.021014],
  [-4.840948, -46.021020],
  [-4.840984, -46.021020],
  [-4.841041, -46.021003],
  [-4.841072, -46.020981],
  [-4.841122, -46.020906],
  [-4.841450, -46.020856],
  [-4.841692, -46.020811],
  [-4.841896, -46.020772],
  [-4.841980, -46.020744],
  [-4.842067, -46.020734],
  [-4.842125, -46.020724],
  [-4.842183, -46.020731],
  [-4.842231, -46.020752],
  [-4.842258, -46.020789],
  [-4.842314, -46.020871],
  [-4.842323, -46.020936],
  [-4.842305, -46.021060],
  [-4.842274, -46.021100],
  [-4.842199, -46.021140],
  [-4.842131, -46.021154],
  [-4.842081, -46.021195],
  [-4.842157, -46.021366],
  [-4.842184, -46.021384],
  [-4.842242, -46.021391],
  [-4.842289, -46.021399],
  [-4.842339, -46.021448],
  [-4.842362, -46.021444],
  [-4.842384, -46.021478],
  [-4.842397, -46.021523],
  [-4.842397, -46.021561],
  [-4.842402, -46.021604],
  [-4.842443, -46.021639],
  [-4.842495, -46.021648],
  [-4.842561, -46.021629],
  [-4.842667, -46.021585],
  [-4.842781, -46.021504],
  [-4.842829, -46.021478],
  [-4.842878, -46.021431],
  [-4.842911, -46.021351],
  [-4.842921, -46.021310],
  [-4.842941, -46.021234],
  [-4.842956, -46.021172],
  [-4.842985, -46.021093],
  [-4.843021, -46.021014],
  [-4.843067, -46.020881],
  [-4.843075, -46.020754],
  [-4.843109, -46.020622],
  [-4.843121, -46.020594],
  [-4.843169, -46.020508],
  [-4.843237, -46.020413],
  [-4.843279, -46.020361],
  [-4.843348, -46.020318],
  [-4.843513, -46.020148],
  [-4.843727, -46.019998],
  [-4.843959, -46.019851],
  [-4.844056, -46.019781],
  [-4.844115, -46.019756],
  [-4.844169, -46.019741],
  [-4.844222, -46.019740],
  [-4.844269, -46.019759],
  [-4.844304, -46.019790],
  [-4.844348, -46.019808],
  [-4.844445, -46.019807],
  [-4.844520, -46.019772],
  [-4.844559, -46.019726],
  [-4.844588, -46.019668],
  [-4.844608, -46.019561],
  [-4.844605, -46.019421],
  [-4.844597, -46.019368],
  [-4.844579, -46.019323],
  [-4.844540, -46.019294],
  [-4.844509, -46.019283],
  [-4.844490, -46.019287],
  [-4.844452, -46.019333],
  [-4.844374, -46.019408],
  [-4.844337, -46.019425],
  [-4.844296, -46.019413],
  [-4.844279, -46.019398],
  [-4.844247, -46.019323],
  [-4.844224, -46.019242],
  [-4.844220, -46.019193],
  [-4.844230, -46.019099],
  [-4.844253, -46.019056],
  [-4.844296, -46.019015],
  [-4.844324, -46.018971],
  [-4.844338, -46.018927],
  [-4.844342, -46.018883],
  [-4.844349, -46.018840],
  [-4.844342, -46.018798],
  [-4.844325, -46.018745],
  [-4.844321, -46.018705],
  [-4.844330, -46.018661],
  [-4.844344, -46.018649],
  [-4.844366, -46.018638],
  [-4.844395, -46.018639],
  [-4.844419, -46.018661],
  [-4.844433, -46.018661],
  [-4.844449, -46.018657],
  [-4.844459, -46.018646],
  [-4.844463, -46.018632],
  [-4.844459, -46.018517],
  [-4.844491, -46.018367],
  [-4.844512, -46.018227],
  [-4.844524, -46.018168],
  [-4.844544, -46.018115],
  [-4.844562, -46.018077],
  [-4.844626, -46.017978],
  [-4.844661, -46.017907],
  [-4.844705, -46.017823],
  [-4.844738, -46.017732],
  [-4.844751, -46.017617],
  [-4.844767, -46.017578],
  [-4.844850, -46.017502],
  [-4.844943, -46.017441],
  [-4.845023, -46.017397],
  [-4.845048, -46.017377],
  [-4.845104, -46.017275],
  [-4.845119, -46.017187],
  [-4.845189, -46.017108],
  [-4.845235, -46.016922],
  [-4.845251, -46.016908],
  [-4.845285, -46.016896],
  [-4.845314, -46.016891],
  [-4.845376, -46.016895],
  [-4.845430, -46.016913],
  [-4.845466, -46.016919],
  [-4.845501, -46.016908],
  [-4.845514, -46.016890],
  [-4.845522, -46.016869],
  [-4.845522, -46.016833],
  [-4.845511, -46.016777],
  [-4.845518, -46.016717],
  [-4.845622, -46.016611],
  [-4.845725, -46.016542],
  [-4.845765, -46.016504],
  [-4.845765, -46.016504],
  [-4.845909, -46.016367],
  [-4.846009, -46.016273],
  [-4.846087, -46.016145],
  [-4.846205, -46.015997],
  [-4.846299, -46.015936],
  [-4.846357, -46.015919],
  [-4.846466, -46.015919],
  [-4.846506, -46.015936],
  [-4.846578, -46.015984],
  [-4.846642, -46.015996],
  [-4.846674, -46.015986],
  [-4.846697, -46.015965],
  [-4.846715, -46.015922],
  [-4.846739, -46.015732],
  [-4.846721, -46.015655],
  [-4.846681, -46.015587],
  [-4.846640, -46.015517],
  [-4.846633, -46.015493],
  [-4.846635, -46.015455],
  [-4.846651, -46.015408],
  [-4.846684, -46.015346],
  [-4.846718, -46.015278],
  [-4.846769, -46.015226],
  [-4.846788, -46.015216],
  [-4.846819, -46.015211],
  [-4.846868, -46.015211],
  [-4.846871, -46.014943],
  [-4.846956, -46.014865],
  [-4.846983, -46.014778],
  [-4.846985, -46.014712],
  [-4.847004, -46.014671],
  [-4.847032, -46.014637],
  [-4.847065, -46.014608],
  [-4.847107, -46.014601],
  [-4.847146, -46.014603],
  [-4.847255, -46.014617],
  [-4.847330, -46.014616],
  [-4.847397, -46.014591],
  [-4.847467, -46.014551],
  [-4.847598, -46.014485],
  [-4.847685, -46.014450],
  [-4.847758, -46.014432],
  [-4.847794, -46.014430],
  [-4.847831, -46.014442],
  [-4.847909, -46.014459],
  [-4.848028, -46.014472],
  [-4.848077, -46.014520],
  [-4.848012, -46.014619],
  [-4.847976, -46.014847],
  [-4.847979, -46.015078],
  [-4.848000, -46.015245],
  [-4.848021, -46.015291],
  [-4.848049, -46.015304],
  [-4.848093, -46.015297],
  [-4.848171, -46.015267],
  [-4.848399, -46.015135],
  [-4.848521, -46.015084],
  [-4.848570, -46.015062],
  [-4.848627, -46.015053],
  [-4.848690, -46.015065],
  [-4.848762, -46.015088],
  [-4.848827, -46.015110],
  [-4.848871, -46.015148],
  [-4.848918, -46.015231],
  [-4.848960, -46.015371],
  [-4.849162, -46.015436],
  [-4.849229, -46.015433],
  [-4.849253, -46.015421],
  [-4.849273, -46.015403],
  [-4.849359, -46.015241],
  [-4.849455, -46.015149],
  [-4.849491, -46.015110],
  [-4.849537, -46.015089],
  [-4.849592, -46.015081],
  [-4.849633, -46.015094],
  [-4.849673, -46.015117],
  [-4.849689, -46.015156],
  [-4.849696, -46.015199],
  [-4.849676, -46.015241],
  [-4.849608, -46.015283],
  [-4.849480, -46.015341],
  [-4.849423, -46.015395],
  [-4.849418, -46.015429],
  [-4.849424, -46.015465],
  [-4.849468, -46.015507],
  [-4.849535, -46.015533],
  [-4.849590, -46.015525],
  [-4.849667, -46.015494],
  [-4.849798, -46.015423],
  [-4.849947, -46.015348],
  [-4.850041, -46.015263],
  [-4.850126, -46.015136],
  [-4.850165, -46.015042],
  [-4.850155, -46.014944],
  [-4.850165, -46.014876],
  [-4.850181, -46.014847],
  [-4.850319, -46.014795],
  [-4.850376, -46.014713],
  [-4.850413, -46.014701],
  [-4.850454, -46.014699],
  [-4.850500, -46.014712],
  [-4.850567, -46.014780],
  [-4.850601, -46.014805],
  [-4.850646, -46.014813],
  [-4.850681, -46.014788],
  [-4.850690, -46.014746],
  [-4.850700, -46.014658],
  [-4.850542, -46.014516],
  [-4.850535, -46.014496],
  [-4.850544, -46.014474],
  [-4.850565, -46.014449],
  [-4.850602, -46.014433],
  [-4.850749, -46.014375],
  [-4.850811, -46.014311],
  [-4.850802, -46.014274],
  [-4.850809, -46.014240],
  [-4.850821, -46.014229],
  [-4.850845, -46.014229],
  [-4.850868, -46.014228],
  [-4.850892, -46.014237],
  [-4.850916, -46.014275],
  [-4.850924, -46.014323],
  [-4.850884, -46.014401],
  [-4.850884, -46.014401],
  [-4.850923, -46.014420],
  [-4.850923, -46.014420],
  [-4.851022, -46.014381],
  [-4.851121, -46.014352],
  [-4.851376, -46.014276],
  [-4.852017, -46.014322],
  [-4.852457, -46.014374],
  [-4.852720, -46.014404],
  [-4.852977, -46.014458],
  [-4.853031, -46.014466],
  [-4.853282, -46.014431],
  [-4.853369, -46.014311],
  [-4.853414, -46.014269],
  [-4.853466, -46.014215],
  [-4.853495, -46.014167],
  [-4.853483, -46.014155],
  [-4.853322, -46.014027],
  [-4.853247, -46.013981],
  [-4.853245, -46.013927],
  [-4.853253, -46.013903],
  [-4.853272, -46.013879],
  [-4.853321, -46.013855],
  [-4.853408, -46.013584],
  [-4.853350, -46.013462],
  [-4.853347, -46.013423],
  [-4.853363, -46.013344],
  [-4.853382, -46.013311],
  [-4.853399, -46.013293],
  [-4.853454, -46.013280],
  [-4.853498, -46.013277],
  [-4.853566, -46.013270],
  [-4.853605, -46.013257],
  [-4.853630, -46.013233],
  [-4.853659, -46.013145],
  [-4.853641, -46.013104],
  [-4.853548, -46.013056],
  [-4.853506, -46.013018],
  [-4.853475, -46.012976],
  [-4.853420, -46.012818],
  [-4.853413, -46.012768],
  [-4.853427, -46.012717],
  [-4.853454, -46.012691],
  [-4.853472, -46.012679],
  [-4.853522, -46.012659],
  [-4.853542, -46.012657],
  [-4.853556, -46.012665],
  [-4.853567, -46.012676],
  [-4.853582, -46.012702],
  [-4.853600, -46.012755],
  [-4.853622, -46.012788],
  [-4.853644, -46.012798],
  [-4.853658, -46.012802],
  [-4.853696, -46.012800],
  [-4.853753, -46.012768],
  [-4.853794, -46.012729],
  [-4.853876, -46.012634],
  [-4.854030, -46.012342],
  [-4.854049, -46.012281],
  [-4.854078, -46.012237],
  [-4.854120, -46.012207],
  [-4.854169, -46.012190],
  [-4.854251, -46.012176],
  [-4.854299, -46.012176],
  [-4.854345, -46.012180],
  [-4.854400, -46.012202],
  [-4.854441, -46.012210],
  [-4.854485, -46.012202],
  [-4.854503, -46.012192],
  [-4.854529, -46.012137],
  [-4.854534, -46.012091],
  [-4.854557, -46.012054],
  [-4.854604, -46.012029],
  [-4.854685, -46.012013],
  [-4.854705, -46.011997],
  [-4.854708, -46.011932],
  [-4.854705, -46.011878],
  [-4.854690, -46.011808],
  [-4.854709, -46.011757],
  [-4.854749, -46.011718],
  [-4.854791, -46.011707],
  [-4.854833, -46.011704],
  [-4.854887, -46.011715],
  [-4.854934, -46.011749],
  [-4.854971, -46.011796],
  [-4.855028, -46.011825],
  [-4.855056, -46.011821],
  [-4.855255, -46.011652],
  [-4.855328, -46.011619],
  [-4.855363, -46.011614],
  [-4.855430, -46.011619],
  [-4.855471, -46.011662],
  [-4.855477, -46.011685],
  [-4.855466, -46.011789],
  [-4.855482, -46.011834],
  [-4.855496, -46.011851],
  [-4.855507, -46.011859],
  [-4.855524, -46.011867],
  [-4.855542, -46.011867],
  [-4.855583, -46.011857],
  [-4.855645, -46.011808],
  [-4.855758, -46.011506],
  [-4.855819, -46.011448],
  [-4.855914, -46.011448],
  [-4.856038, -46.011466],
  [-4.856164, -46.011455],
  [-4.856286, -46.011439],
  [-4.856386, -46.011416],
  [-4.856403, -46.011417],
  [-4.856423, -46.011424],
  [-4.856470, -46.011473],
  [-4.856532, -46.011553],
  [-4.856745, -46.011558],
  [-4.856772, -46.011560],
  [-4.856832, -46.011575],
  [-4.856849, -46.011589],
  [-4.856863, -46.011601],
  [-4.856875, -46.011618],
  [-4.856909, -46.011737],
  [-4.856948, -46.011868],
  [-4.856956, -46.011896],
  [-4.856997, -46.011920],
  [-4.857072, -46.011926],
  [-4.857110, -46.011936],
  [-4.857142, -46.011953],
  [-4.857148, -46.011972],
  [-4.857133, -46.012002],
  [-4.857103, -46.012021],
  [-4.857058, -46.012050],
  [-4.857009, -46.012144],
  [-4.857020, -46.012162],
  [-4.857066, -46.012195],
  [-4.857102, -46.012208],
  [-4.857162, -46.012245],
  [-4.857379, -46.012274],
  [-4.857434, -46.012274],
  [-4.857590, -46.012257],
  [-4.857825, -46.012161],
  [-4.857958, -46.012112],
  [-4.857985, -46.012092],
  [-4.858057, -46.012090],
  [-4.858133, -46.012115],
  [-4.858193, -46.012141],
  [-4.858245, -46.012191],
  [-4.858329, -46.012318],
  [-4.858389, -46.012396],
  [-4.858407, -46.012416],
  [-4.858430, -46.012427],
  [-4.858462, -46.012436],
  [-4.858496, -46.012432],
  [-4.858750, -46.012299],
  [-4.858791, -46.012285],
  [-4.858823, -46.012288],
  [-4.858840, -46.012292],
  [-4.858858, -46.012302],
  [-4.858875, -46.012315],
  [-4.858921, -46.012373],
  [-4.858989, -46.012433],
  [-4.859054, -46.012458],
  [-4.859286, -46.012517],
  [-4.859304, -46.012519],
  [-4.859368, -46.012493],
  [-4.859528, -46.012345],
  [-4.859555, -46.012314],
  [-4.859555, -46.012300],
  [-4.859529, -46.012230],
  [-4.859518, -46.012100],
  [-4.859538, -46.012034],
  [-4.859899, -46.011997],
  [-4.859959, -46.012000],
  [-4.860068, -46.012039],
  [-4.860134, -46.012065],
  [-4.860210, -46.012067],
  [-4.860275, -46.012077],
  [-4.860296, -46.012083],
  [-4.860319, -46.012099],
  [-4.860318, -46.012123],
  [-4.860234, -46.012227],
  [-4.860234, -46.012245],
  [-4.860295, -46.012317],
  [-4.860347, -46.012357],
  [-4.860405, -46.012387],
  [-4.860439, -46.012395],
  [-4.860480, -46.012395],
  [-4.860542, -46.012355],
  [-4.860576, -46.012324],
  [-4.860596, -46.012294],
  [-4.860608, -46.012237],
  [-4.860609, -46.012163],
  [-4.860626, -46.012107],
  [-4.860662, -46.012071],
  [-4.860671, -46.012049],
  [-4.860653, -46.012024],
  [-4.860653, -46.012024],
  [-4.860606, -46.012005],
  [-4.860579, -46.011968],
  [-4.860587, -46.011950],
  [-4.860613, -46.011907],
  [-4.860632, -46.011896],
  [-4.860648, -46.011884],
  [-4.860730, -46.011851],
  [-4.860718, -46.011867],
  [-4.860758, -46.011849],
  [-4.860810, -46.011811],
  [-4.860901, -46.011763],
  [-4.861141, -46.011740],
  [-4.861192, -46.011758],
  [-4.861203, -46.011769],
  [-4.861234, -46.011819],
  [-4.861271, -46.011862],
  [-4.861286, -46.011902],
  [-4.861288, -46.011931],
  [-4.861274, -46.011939],
  [-4.861244, -46.011934],
  [-4.861220, -46.011930],
  [-4.861188, -46.011931],
  [-4.861158, -46.011939],
  [-4.861139, -46.011961],
  [-4.861135, -46.011984],
  [-4.861138, -46.012009],
  [-4.861148, -46.012027],
  [-4.861184, -46.012047],
  [-4.861296, -46.012075],
  [-4.861342, -46.012052],
  [-4.861377, -46.012040],
  [-4.861412, -46.012045],
  [-4.861469, -46.012072],
  [-4.861778, -46.012284],
  [-4.861817, -46.012287],
  [-4.861885, -46.012284],
  [-4.861947, -46.012271],
  [-4.862035, -46.012250],
  [-4.862142, -46.012189],
  [-4.862312, -46.012057],
  [-4.862341, -46.012052],
  [-4.862374, -46.012052],
  [-4.862388, -46.012047],
  [-4.862402, -46.012029],
  [-4.862436, -46.011955],
  [-4.862451, -46.011914],
  [-4.862456, -46.011887],
  [-4.862460, -46.011857],
  [-4.862460, -46.011843],
  [-4.862462, -46.011823],
  [-4.862492, -46.011744],
  [-4.862526, -46.011722],
  [-4.862552, -46.011715],
  [-4.862580, -46.011715],
  [-4.862604, -46.011712],
  [-4.862638, -46.011703],
  [-4.862650, -46.011690],
  [-4.862662, -46.011671],
  [-4.862715, -46.011528],
  [-4.862726, -46.011501],
  [-4.862732, -46.011477],
  [-4.862724, -46.011457],
  [-4.862701, -46.011428],
  [-4.862667, -46.011405],
  [-4.862633, -46.011397],
  [-4.862612, -46.011398],
  [-4.862595, -46.011411],
  [-4.862571, -46.011454],
  [-4.862556, -46.011465],
  [-4.862538, -46.011465],
  [-4.862508, -46.011453],
  [-4.862498, -46.011442],
  [-4.862472, -46.011288],
  [-4.862616, -46.011110],
  [-4.862646, -46.011095],
  [-4.862732, -46.011045],
  [-4.862748, -46.011023],
  [-4.862747, -46.011001],
  [-4.862740, -46.010979],
  [-4.862727, -46.010959],
  [-4.862722, -46.010943],
  [-4.862723, -46.010925],
  [-4.862733, -46.010900],
  [-4.862747, -46.010874],
  [-4.862815, -46.010836],
  [-4.862893, -46.010789],
  [-4.863098, -46.010712],
  [-4.863133, -46.010702],
  [-4.863190, -46.010730],
  [-4.863225, -46.010758],
  [-4.863260, -46.010787],
  [-4.863280, -46.010800],
  [-4.863306, -46.010808],
  [-4.863331, -46.010809],
  [-4.863356, -46.010802],
  [-4.863381, -46.010771],
  [-4.863384, -46.010755],
  [-4.863379, -46.010738],
  [-4.863369, -46.010710],
  [-4.863361, -46.010678],
  [-4.863328, -46.010617],
  [-4.863327, -46.010562],
  [-4.863342, -46.010534],
  [-4.863362, -46.010497],
  [-4.863395, -46.010466],
  [-4.863456, -46.010433],
  [-4.863518, -46.010409],
  [-4.863586, -46.010401],
  [-4.863641, -46.010403],
  [-4.863695, -46.010403],
  [-4.863718, -46.010414],
  [-4.863755, -46.010409],
  [-4.863802, -46.010422],
  [-4.863833, -46.010443],
  [-4.863856, -46.010480],
  [-4.863861, -46.010526],
  [-4.863872, -46.010553],
  [-4.863900, -46.010583],
  [-4.863902, -46.010628],
  [-4.863970, -46.010692],
  [-4.863998, -46.010715],
  [-4.864024, -46.010750],
  [-4.864064, -46.010770],
  [-4.864139, -46.010770],
  [-4.864175, -46.010750],
  [-4.864224, -46.010662],
  [-4.864297, -46.010592],
  [-4.864333, -46.010579],
  [-4.864367, -46.010575],
  [-4.864393, -46.010555],
  [-4.864421, -46.010544],
  [-4.864448, -46.010537],
  [-4.864476, -46.010536],
  [-4.864502, -46.010539],
  [-4.864528, -46.010547],
  [-4.864565, -46.010568],
  [-4.864598, -46.010575],
  [-4.864618, -46.010599],
  [-4.864710, -46.010763],
  [-4.864826, -46.010822],
  [-4.865050, -46.010884],
  [-4.865111, -46.010923],
  [-4.865127, -46.010928],
  [-4.865203, -46.010926],
  [-4.865258, -46.010936],
  [-4.865307, -46.010936],
  [-4.865372, -46.010936],
  [-4.865457, -46.010941],
  [-4.865491, -46.010948],
  [-4.865554, -46.010982],
  [-4.865642, -46.011003],
  [-4.865718, -46.011025],
  [-4.865759, -46.011045],
  [-4.865781, -46.011055],
  [-4.865794, -46.011068],
  [-4.865803, -46.011086],
  [-4.865813, -46.011125],
  [-4.865814, -46.011149],
  [-4.865808, -46.011179],
  [-4.865790, -46.011226],
  [-4.865788, -46.011239],
  [-4.865788, -46.011255],
  [-4.865795, -46.011281],
  [-4.865807, -46.011302],
  [-4.865829, -46.011316],
  [-4.865857, -46.011333],
  [-4.865866, -46.011355],
  [-4.865873, -46.011397],
  [-4.865870, -46.011418],
  [-4.865855, -46.011433],
  [-4.865830, -46.011437],
  [-4.865821, -46.011446],
  [-4.865812, -46.011481],
  [-4.865821, -46.011500],
  [-4.865839, -46.011518],
  [-4.865858, -46.011533],
  [-4.865882, -46.011544],
  [-4.865916, -46.011565],
  [-4.865938, -46.011586],
  [-4.865974, -46.011604],
  [-4.866033, -46.011620],
  [-4.866100, -46.011652],
  [-4.866120, -46.011675],
  [-4.866152, -46.011690],
  [-4.866202, -46.011686],
  [-4.866228, -46.011678],
  [-4.866268, -46.011657],
  [-4.866313, -46.011615],
  [-4.866328, -46.011607],
  [-4.866346, -46.011587],
  [-4.866362, -46.011577],
  [-4.866391, -46.011555],
  [-4.866435, -46.011527],
  [-4.866473, -46.011498],
  [-4.866490, -46.011459],
  [-4.866508, -46.011414],
  [-4.866536, -46.011391],
  [-4.866580, -46.011381],
  [-4.866613, -46.011377],
  [-4.866639, -46.011388],
  [-4.866997, -46.011780],
  [-4.867122, -46.011838],
  [-4.867197, -46.011905],
  [-4.867234, -46.012023],
  [-4.867265, -46.012101],
  [-4.867269, -46.012139],
  [-4.867244, -46.012237],
  [-4.867247, -46.012265],
  [-4.867301, -46.012395],
  [-4.867302, -46.012577],
  [-4.867307, -46.012607],
  [-4.867318, -46.012638],
  [-4.867326, -46.012650],
  [-4.867338, -46.012658],
  [-4.867404, -46.012682],
  [-4.867419, -46.012693],
  [-4.867437, -46.012700],
  [-4.867472, -46.012690],
  [-4.867507, -46.012668],
  [-4.867543, -46.012641],
  [-4.867557, -46.012635],
  [-4.867572, -46.012634],
  [-4.867585, -46.012635],
  [-4.867612, -46.012654],
  [-4.867637, -46.012668],
  [-4.867711, -46.012680],
  [-4.867753, -46.012709],
  [-4.867768, -46.012724],
  [-4.867773, -46.012737],
  [-4.867773, -46.012800],
  [-4.867775, -46.012835],
  [-4.867775, -46.012875],
  [-4.867788, -46.012902],
  [-4.867797, -46.012913],
  [-4.867817, -46.012925],
  [-4.867866, -46.012926],
  [-4.867911, -46.012917],
  [-4.867952, -46.012907],
  [-4.868002, -46.012903],
  [-4.868024, -46.012917],
  [-4.868029, -46.012930],
  [-4.868028, -46.012945],
  [-4.868023, -46.012959],
  [-4.867990, -46.012977],
  [-4.867981, -46.012992],
  [-4.867977, -46.013009],
  [-4.867979, -46.013021],
  [-4.867997, -46.013038],
  [-4.868023, -46.013051],
  [-4.868059, -46.013078],
  [-4.868088, -46.013086],
  [-4.868138, -46.013089],
  [-4.868244, -46.013073],
  [-4.868259, -46.013064],
  [-4.868307, -46.012990],
  [-4.868339, -46.012970],
  [-4.868365, -46.012961],
  [-4.868398, -46.012962],
  [-4.868433, -46.012970],
  [-4.868471, -46.012970],
  [-4.868495, -46.012961],
  [-4.868513, -46.012948],
  [-4.868580, -46.012895],
  [-4.868647, -46.012848],
  [-4.868725, -46.012795],
  [-4.868832, -46.012740],
  [-4.868878, -46.012732],
  [-4.868892, -46.012733],
  [-4.868906, -46.012736],
  [-4.868914, -46.012742],
  [-4.868921, -46.012751],
  [-4.868923, -46.012761],
  [-4.868918, -46.012768],
  [-4.868875, -46.012792],
  [-4.868843, -46.012799],
  [-4.868814, -46.012811],
  [-4.868797, -46.012832],
  [-4.868790, -46.012864],
  [-4.868798, -46.012923],
  [-4.868873, -46.013079],
  [-4.868913, -46.013154],
  [-4.868953, -46.013197],
  [-4.868971, -46.013210],
  [-4.868998, -46.013215],
  [-4.869025, -46.013210],
  [-4.869045, -46.013202],
  [-4.869069, -46.013181],
  [-4.869073, -46.013164],
  [-4.869103, -46.013130],
  [-4.869112, -46.013081],
  [-4.869145, -46.013053],
  [-4.869154, -46.013033],
  [-4.869145, -46.012989],
  [-4.869146, -46.012974],
  [-4.869151, -46.012963],
  [-4.869168, -46.012937],
  [-4.869197, -46.012871],
  [-4.869205, -46.012837],
  [-4.869238, -46.012803],
  [-4.869300, -46.012772],
  [-4.869329, -46.012760],
  [-4.869364, -46.012754],
  [-4.869399, -46.012752],
  [-4.869544, -46.012779],
  [-4.869667, -46.012808],
  [-4.869707, -46.012824],
  [-4.869726, -46.012856],
  [-4.869785, -46.012904],
  [-4.869842, -46.012936],
  [-4.869904, -46.012987],
  [-4.869990, -46.013011],
  [-4.870064, -46.013054],
  [-4.870101, -46.013071],
  [-4.870135, -46.013075],
  [-4.870161, -46.013068],
  [-4.870173, -46.013060],
  [-4.870170, -46.013048],
  [-4.870160, -46.013040],
  [-4.870083, -46.013016],
  [-4.870069, -46.012987],
  [-4.870066, -46.012964],
  [-4.870074, -46.012940],
  [-4.870085, -46.012924],
  [-4.870101, -46.012908],
  [-4.870110, -46.012887],
  [-4.870114, -46.012858],
  [-4.870109, -46.012836],
  [-4.870111, -46.012821],
  [-4.870152, -46.012737],
  [-4.870153, -46.012662],
  [-4.870161, -46.012642],
  [-4.870188, -46.012620],
  [-4.870213, -46.012608],
  [-4.870227, -46.012607],
  [-4.870241, -46.012609],
  [-4.870256, -46.012632],
  [-4.870267, -46.012683],
  [-4.870267, -46.012747],
  [-4.870259, -46.012779],
  [-4.870259, -46.012797],
  [-4.870264, -46.012811],
  [-4.870283, -46.012828],
  [-4.870307, -46.012839],
  [-4.870343, -46.012839],
  [-4.870365, -46.012833],
  [-4.870388, -46.012822],
  [-4.870453, -46.012784],
  [-4.870528, -46.012753],
  [-4.870689, -46.012721],
  [-4.870718, -46.012721],
  [-4.870782, -46.012716],
  [-4.870886, -46.012718],
  [-4.871001, -46.012721],
  [-4.871049, -46.012727],
  [-4.871079, -46.012729],
  [-4.871093, -46.012733],
  [-4.871116, -46.012748],
  [-4.871137, -46.012780],
  [-4.871139, -46.012796],
  [-4.871138, -46.012811],
  [-4.871127, -46.012831],
  [-4.871096, -46.012871],
  [-4.871073, -46.012903],
  [-4.871065, -46.012927],
  [-4.871070, -46.012944],
  [-4.871080, -46.012957],
  [-4.871107, -46.013003],
  [-4.871118, -46.013013],
  [-4.871162, -46.013038],
  [-4.871215, -46.013061],
  [-4.871231, -46.013074],
  [-4.871247, -46.013118],
  [-4.871265, -46.013163],
  [-4.871274, -46.013171],
  [-4.871288, -46.013177],
  [-4.871492, -46.013216],
  [-4.871645, -46.013225],
  [-4.871788, -46.013267],
  [-4.871816, -46.013281],
  [-4.871888, -46.013346],
  [-4.871916, -46.013353],
  [-4.871935, -46.013348],
  [-4.872025, -46.013348],
  [-4.872155, -46.013290],
  [-4.872254, -46.013284],
  [-4.872378, -46.013227],
  [-4.872400, -46.013222],
  [-4.872512, -46.013216],
  [-4.872527, -46.013218],
  [-4.872541, -46.013228],
  [-4.872554, -46.013258],
  [-4.872566, -46.013314],
  [-4.872554, -46.013350],
  [-4.872556, -46.013365],
  [-4.872575, -46.013390],
  [-4.872576, -46.013410],
  [-4.872558, -46.013440],
  [-4.872566, -46.013445],
  [-4.872549, -46.013478],
  [-4.872515, -46.013504],
  [-4.872515, -46.013534],
  [-4.872539, -46.013564],
  [-4.872570, -46.013587],
  [-4.872611, -46.013604],
  [-4.872665, -46.013609],
  [-4.872697, -46.013607],
  [-4.872723, -46.013598],
  [-4.872743, -46.013580],
  [-4.872754, -46.013550],
  [-4.872754, -46.013520],
  [-4.872740, -46.013493],
  [-4.872676, -46.013381],
  [-4.872673, -46.013332],
  [-4.872686, -46.013289],
  [-4.872711, -46.013244],
  [-4.872743, -46.013222],
  [-4.872793, -46.013193],
  [-4.872826, -46.013185],
  [-4.872855, -46.013185],
  [-4.872895, -46.013193],
  [-4.872962, -46.013255],
  [-4.873028, -46.013397],
  [-4.873048, -46.013406],
  [-4.873071, -46.013408],
  [-4.873085, -46.013407],
  [-4.873119, -46.013378],
  [-4.873156, -46.013322],
  [-4.873199, -46.013260],
  [-4.873246, -46.013172],
  [-4.873280, -46.013080],
  [-4.873305, -46.012996],
  [-4.873300, -46.012974],
  [-4.873275, -46.012957],
  [-4.873267, -46.012938],
  [-4.873272, -46.012926],
  [-4.873281, -46.012918],
  [-4.873299, -46.012915],
  [-4.873315, -46.012919],
  [-4.873334, -46.012918],
  [-4.873442, -46.012916],
  [-4.873485, -46.012902],
  [-4.873522, -46.012884],
  [-4.873548, -46.012878],
  [-4.873586, -46.012886],
  [-4.873622, -46.012906],
  [-4.873686, -46.012954],
  [-4.873704, -46.012986],
  [-4.873705, -46.013018],
  [-4.873712, -46.013045],
  [-4.873739, -46.013077],
  [-4.873771, -46.013101],
  [-4.873793, -46.013109],
  [-4.873852, -46.013118],
  [-4.873882, -46.013107],
  [-4.873960, -46.013071],
  [-4.873995, -46.013063],
  [-4.874034, -46.013048],
  [-4.874086, -46.013015],
  [-4.874155, -46.012954],
  [-4.874239, -46.012914],
  [-4.874310, -46.012922],
  [-4.874336, -46.012935],
  [-4.874413, -46.012932],
  [-4.874475, -46.012953],
  [-4.874489, -46.012966],
  [-4.874497, -46.012986],
  [-4.874469, -46.013126],
  [-4.874465, -46.013162],
  [-4.874465, -46.013184],
  [-4.874480, -46.013202],
  [-4.874510, -46.013221],
  [-4.874536, -46.013228],
  [-4.874564, -46.013232],
  [-4.874591, -46.013231],
  [-4.874620, -46.013224],
  [-4.874663, -46.013194],
  [-4.874698, -46.013153],
  [-4.874709, -46.013114],
  [-4.874684, -46.013051],
  [-4.874661, -46.013032],
  [-4.874638, -46.013027],
  [-4.874632, -46.013022],
  [-4.874625, -46.013003],
  [-4.874624, -46.012991],
  [-4.874625, -46.012981],
  [-4.874634, -46.012955],
  [-4.874634, -46.012955],
  [-4.874652, -46.012945],
  [-4.874668, -46.012945],
  [-4.874689, -46.012951],
  [-4.874708, -46.012958],
  [-4.874748, -46.012993],
  [-4.874791, -46.013054],
  [-4.874834, -46.013121],
  [-4.874877, -46.013207],
  [-4.874899, -46.013234],
  [-4.874931, -46.013251],
  [-4.874972, -46.013272],
  [-4.875017, -46.013285],
  [-4.875047, -46.013286],
  [-4.875080, -46.013285],
  [-4.875113, -46.013280],
  [-4.875144, -46.013273],
  [-4.875172, -46.013258],
  [-4.875200, -46.013234],
  [-4.875229, -46.013191],
  [-4.875248, -46.013135],
  [-4.875265, -46.013085],
  [-4.875268, -46.013036],
  [-4.875175, -46.012836],
  [-4.875174, -46.012805],
  [-4.875179, -46.012785],
  [-4.875196, -46.012769],
  [-4.875218, -46.012764],
  [-4.875239, -46.012764],
  [-4.875256, -46.012768],
  [-4.875268, -46.012786],
  [-4.875281, -46.012823],
  [-4.875330, -46.012910],
  [-4.875357, -46.012945],
  [-4.875373, -46.012953],
  [-4.875394, -46.012949],
  [-4.875400, -46.012936],
  [-4.875358, -46.012719],
  [-4.875366, -46.012695],
  [-4.875375, -46.012684],
  [-4.875384, -46.012678],
  [-4.875408, -46.012675],
  [-4.875427, -46.012684],
  [-4.875445, -46.012696],
  [-4.875454, -46.012711],
  [-4.875461, -46.012757],
  [-4.875461, -46.012842],
  [-4.875467, -46.012861],
  [-4.875491, -46.012869],
  [-4.875510, -46.012863],
  [-4.875529, -46.012840],
  [-4.875572, -46.012749],
  [-4.875602, -46.012702],
  [-4.875630, -46.012686],
  [-4.875671, -46.012689],
  [-4.875704, -46.012698],
  [-4.875733, -46.012714],
  [-4.875763, -46.012743],
  [-4.875802, -46.012810],
  [-4.875827, -46.012826],
  [-4.875851, -46.012853],
  [-4.875870, -46.012877],
  [-4.875875, -46.012910],
  [-4.875861, -46.012982],
  [-4.875808, -46.013047],
  [-4.875800, -46.013083],
  [-4.875805, -46.013113],
  [-4.875819, -46.013137],
  [-4.875845, -46.013156],
  [-4.875975, -46.013188],
  [-4.876015, -46.013212],
  [-4.876071, -46.013240],
  [-4.876154, -46.013263],
  [-4.876193, -46.013289],
  [-4.876235, -46.013296],
  [-4.876367, -46.013298],
  [-4.876460, -46.013277],
  [-4.876552, -46.013280],
  [-4.876622, -46.013314],
  [-4.876684, -46.013396],
  [-4.876746, -46.013497],
  [-4.876765, -46.013511],
  [-4.876790, -46.013516],
  [-4.876817, -46.013514],
  [-4.876840, -46.013506],
  [-4.876907, -46.013473],
  [-4.877001, -46.013410],
  [-4.877021, -46.013377],
  [-4.877111, -46.013318],
  [-4.877147, -46.013300],
  [-4.877178, -46.013282],
  [-4.877225, -46.013247],
  [-4.877284, -46.013210],
  [-4.877310, -46.013165],
  [-4.877331, -46.013131],
  [-4.877343, -46.013122],
  [-4.877366, -46.013078],
  [-4.877379, -46.012994],
  [-4.877392, -46.012945],
  [-4.877407, -46.012926],
  [-4.877428, -46.012915],
  [-4.877450, -46.012909],
  [-4.877487, -46.012902],
  [-4.877517, -46.012905],
  [-4.877543, -46.012922],
  [-4.877566, -46.012949],
  [-4.877608, -46.013028],
  [-4.877620, -46.013105],
  [-4.877650, -46.013129],
  [-4.877688, -46.013121],
  [-4.877772, -46.013110],
  [-4.877793, -46.013110],
  [-4.877820, -46.013116],
  [-4.877834, -46.013134],
  [-4.877836, -46.013157],
  [-4.877833, -46.013199],
  [-4.877849, -46.013238],
  [-4.877851, -46.013251],
  [-4.877855, -46.013272],
  [-4.877893, -46.013336],
  [-4.877903, -46.013355],
  [-4.877893, -46.013376],
  [-4.877864, -46.013408],
  [-4.877826, -46.013448],
  [-4.877822, -46.013456],
  [-4.877821, -46.013465],
  [-4.877838, -46.013481],
  [-4.877850, -46.013492],
  [-4.877890, -46.013513],
  [-4.877927, -46.013516],
  [-4.878019, -46.013503],
  [-4.878083, -46.013510],
  [-4.878104, -46.013508],
  [-4.878134, -46.013500],
  [-4.878159, -46.013505],
  [-4.878180, -46.013516],
  [-4.878194, -46.013546],
  [-4.878220, -46.013581],
  [-4.878244, -46.013592],
  [-4.878278, -46.013598],
  [-4.878338, -46.013608],
  [-4.878387, -46.013596],
  [-4.878711, -46.013373],
  [-4.878738, -46.013331],
  [-4.878778, -46.013312],
  [-4.878845, -46.013299],
  [-4.878918, -46.013267],
  [-4.878964, -46.013220],
  [-4.879002, -46.013153],
  [-4.879022, -46.013125],
  [-4.879050, -46.013108],
  [-4.879067, -46.013106],
  [-4.879115, -46.013116],
  [-4.879222, -46.013102],
  [-4.879287, -46.013098],
  [-4.879307, -46.013095],
  [-4.879320, -46.013065],
  [-4.879381, -46.013059],
  [-4.879422, -46.013020],
  [-4.879476, -46.012956],
  [-4.879489, -46.012933],
  [-4.879499, -46.012916],
  [-4.879547, -46.012912],
  [-4.879566, -46.012901],
  [-4.879586, -46.012893],
  [-4.879617, -46.012867],
  [-4.879654, -46.012843],
  [-4.879694, -46.012833],
  [-4.879726, -46.012836],
  [-4.879768, -46.012841],
  [-4.879817, -46.012847],
  [-4.879844, -46.012847],
  [-4.879872, -46.012839],
  [-4.879895, -46.012831],
  [-4.879937, -46.012812],
  [-4.879989, -46.012821],
  [-4.880028, -46.012840],
  [-4.880034, -46.012853],
  [-4.880035, -46.012883],
  [-4.880018, -46.012937],
  [-4.879984, -46.013052],
  [-4.879958, -46.013070],
  [-4.879934, -46.013096],
  [-4.879907, -46.013137],
  [-4.879889, -46.013151],
  [-4.879883, -46.013180],
  [-4.879883, -46.013207],
  [-4.879887, -46.013232],
  [-4.879906, -46.013263],
  [-4.879927, -46.013284],
  [-4.879950, -46.013304],
  [-4.879979, -46.013318],
  [-4.880021, -46.013328],
  [-4.880063, -46.013346],
  [-4.880115, -46.013370],
  [-4.880131, -46.013381],
  [-4.880157, -46.013411],
  [-4.880204, -46.013430],
  [-4.880246, -46.013433],
  [-4.880315, -46.013444],
  [-4.880344, -46.013444],
  [-4.880373, -46.013437],
  [-4.880397, -46.013429],
  [-4.880451, -46.013394],
  [-4.880484, -46.013386],
  [-4.880515, -46.013392],
  [-4.880564, -46.013391],
  [-4.880580, -46.013394],
  [-4.880606, -46.013389],
  [-4.880663, -46.013352],
  [-4.880712, -46.013347],
  [-4.880736, -46.013345],
  [-4.880758, -46.013351],
  [-4.880787, -46.013366],
  [-4.880890, -46.013414],
  [-4.880905, -46.013426],
  [-4.880919, -46.013446],
  [-4.880970, -46.013476],
  [-4.881017, -46.013492],
  [-4.881068, -46.013498],
  [-4.881094, -46.013501],
  [-4.881121, -46.013500],
  [-4.881148, -46.013492],
  [-4.881169, -46.013485],
  [-4.881198, -46.013486],
  [-4.881354, -46.013512],
  [-4.881365, -46.013508],
  [-4.881383, -46.013497],
  [-4.881424, -46.013491],
  [-4.881484, -46.013496],
  [-4.881563, -46.013489],
  [-4.881620, -46.013492],
  [-4.881712, -46.013496],
  [-4.881777, -46.013499],
  [-4.881830, -46.013503],
  [-4.881885, -46.013499],
  [-4.881901, -46.013496],
  [-4.881913, -46.013487],
  [-4.881945, -46.013469],
  [-4.881963, -46.013451],
  [-4.881993, -46.013421],
  [-4.881993, -46.013421],
  [-4.882023, -46.013407],
  [-4.882035, -46.013403],
  [-4.882049, -46.013404],
  [-4.882087, -46.013409],
  [-4.882137, -46.013401],
  [-4.882159, -46.013395],
  [-4.882202, -46.013381],
  [-4.882279, -46.013350],
  [-4.882351, -46.013317],
  [-4.882446, -46.013278],
  [-4.882540, -46.013242],
  [-4.882629, -46.013226],
  [-4.882666, -46.013227],
  [-4.882799, -46.013181],
  [-4.882868, -46.013138],
  [-4.882903, -46.013084],
  [-4.883073, -46.012958],
  [-4.883146, -46.012862],
  [-4.883223, -46.012719],
  [-4.883280, -46.012585],
  [-4.883274, -46.012552],
  [-4.883271, -46.012525],
  [-4.883226, -46.012486],
  [-4.883209, -46.012458],
  [-4.883207, -46.012423],
  [-4.883226, -46.012384],
  [-4.883293, -46.012314],
  [-4.883326, -46.012285],
  [-4.883373, -46.012260],
  [-4.883409, -46.012258],
  [-4.883463, -46.012243],
  [-4.883565, -46.012245],
  [-4.883626, -46.012257],
  [-4.883761, -46.012268],
  [-4.883761, -46.012268],
  [-4.883869, -46.012329],
  [-4.883965, -46.012445],
  [-4.884004, -46.012520],
  [-4.884086, -46.012547],
  [-4.884525, -46.012646],
  [-4.884708, -46.012690],
  [-4.885113, -46.012843],
  [-4.885298, -46.012888],
  [-4.885570, -46.012912],
  [-4.885623, -46.012882],
  [-4.885664, -46.012821],
  [-4.885699, -46.012799],
  [-4.885760, -46.012795],
  [-4.885830, -46.012789],
  [-4.885884, -46.012808],
  [-4.886003, -46.012880],
  [-4.886078, -46.012897],
  [-4.886164, -46.012891],
  [-4.886289, -46.012865],
  [-4.886502, -46.012850],
  [-4.886620, -46.012850],
  [-4.886789, -46.012840],
  [-4.886866, -46.012837],
  [-4.886936, -46.012834],
  [-4.887121, -46.012882],
  [-4.887280, -46.012904],
  [-4.887446, -46.012907],
  [-4.887586, -46.012875],
  [-4.887653, -46.012875],
  [-4.887736, -46.012894],
  [-4.887859, -46.012955],
  [-4.888000, -46.013009],
  [-4.888045, -46.013032],
  [-4.888122, -46.013057],
  [-4.888191, -46.013101],
  [-4.888349, -46.013154],
  [-4.888456, -46.013181],
  [-4.888646, -46.013399],
  [-4.888800, -46.013688],
  [-4.888851, -46.013723],
  [-4.888995, -46.013761],
  [-4.889160, -46.014007],
  [-4.889226, -46.014120],
  [-4.889272, -46.014163],
  [-4.889364, -46.014188],
  [-4.889536, -46.014233],
  [-4.889718, -46.014246],
  [-4.889820, -46.014313],
  [-4.889880, -46.014339],
  [-4.889979, -46.014348],
  [-4.890183, -46.014325],
  [-4.890528, -46.014344],
  [-4.890655, -46.014373],
  [-4.890773, -46.014434],
  [-4.890999, -46.014424],
  [-4.891286, -46.014300],
  [-4.891447, -46.014287],
  [-4.891581, -46.014408],
  [-4.891753, -46.014666],
  [-4.891900, -46.014912],
  [-4.892017, -46.015055],
  [-4.892147, -46.015192],
  [-4.892344, -46.015242],
  [-4.892443, -46.015199],
  [-4.892604, -46.015167],
  [-4.892647, -46.015178],
  [-4.892676, -46.015238],
  [-4.892723, -46.015270],
  [-4.892864, -46.015272],
  [-4.892968, -46.015214],
  [-4.892996, -46.015171],
  [-4.893055, -46.015201],
  [-4.893087, -46.015321],
  [-4.893127, -46.015387],
  [-4.893165, -46.015409],
  [-4.893201, -46.015417],
  [-4.893276, -46.015399],
  [-4.893313, -46.015377],
  [-4.893332, -46.015342],
  [-4.893311, -46.015246],
  [-4.893328, -46.015162],
  [-4.893425, -46.015104],
  [-4.893491, -46.015099],
  [-4.893621, -46.015042],
  [-4.893681, -46.015036],
  [-4.893727, -46.015052],
  [-4.893782, -46.015079],
  [-4.893821, -46.015141],
  [-4.893866, -46.015273],
  [-4.893877, -46.015366],
  [-4.893891, -46.015399],
  [-4.894141, -46.015318],
  [-4.894146, -46.015066],
  [-4.893954, -46.014663],
  [-4.893952, -46.014585],
  [-4.893976, -46.014550],
  [-4.894008, -46.014526],
  [-4.894107, -46.014497],
  [-4.894171, -46.014497],
  [-4.894273, -46.014534],
  [-4.894318, -46.014552],
  [-4.894557, -46.014683],
  [-4.894704, -46.014641],
  [-4.894746, -46.014626],
  [-4.894889, -46.014677],
  [-4.895005, -46.014660],
  [-4.895060, -46.014588],
  [-4.895071, -46.014469],
  [-4.895085, -46.014367],
  [-4.895107, -46.014281],
  [-4.895136, -46.014246],
  [-4.895206, -46.014249],
  [-4.895268, -46.014290],
  [-4.895351, -46.014365],
  [-4.895404, -46.014488],
  [-4.895417, -46.014542],
  [-4.895498, -46.014520],
  [-4.895533, -46.014472],
  [-4.895534, -46.014443],
  [-4.895341, -46.014317],
  [-4.895346, -46.014234],
  [-4.895426, -46.014179],
  [-4.895492, -46.014186],
  [-4.895526, -46.014201],
  [-4.895595, -46.014258],
  [-4.895595, -46.014258],
  [-4.895668, -46.014352],
  [-4.895775, -46.014426],
  [-4.895821, -46.014422],
  [-4.896110, -46.014314],
  [-4.896216, -46.014354],
  [-4.896293, -46.014714],
  [-4.896288, -46.014865],
  [-4.896244, -46.014969],
  [-4.896173, -46.015034],
  [-4.896119, -46.015079],
  [-4.896182, -46.015089],
  [-4.896247, -46.015068],
  [-4.896347, -46.015028],
  [-4.896420, -46.015046],
  [-4.896432, -46.015135],
  [-4.896438, -46.015184],
  [-4.896465, -46.015210],
  [-4.896575, -46.015238],
  [-4.896744, -46.015275],
  [-4.896798, -46.015275],
  [-4.896997, -46.015214],
  [-4.897051, -46.015206],
  [-4.897007, -46.015391],
  [-4.897031, -46.015527],
  [-4.897090, -46.015591],
  [-4.897200, -46.015592],
  [-4.897437, -46.015583],
  [-4.897512, -46.015588],
  [-4.897644, -46.015613],
  [-4.897715, -46.015632],
  [-4.897747, -46.015649],
  [-4.897777, -46.015694],
  [-4.897730, -46.015788],
  [-4.897765, -46.015891],
  [-4.897785, -46.016014],
  [-4.897929, -46.016307],
  [-4.898002, -46.016446],
  [-4.898120, -46.016479],
  [-4.898429, -46.016460],
  [-4.898636, -46.016444],
  [-4.898730, -46.016538],
  [-4.898845, -46.016642],
  [-4.899011, -46.016572],
  [-4.899060, -46.016514],
  [-4.899204, -46.016441],
  [-4.899296, -46.016358],
  [-4.899607, -46.016397],
  [-4.899634, -46.016410],
  [-4.899661, -46.016455],
  [-4.899699, -46.016583],
  [-4.899703, -46.016680],
  [-4.899694, -46.016725],
  [-4.899721, -46.016779],
  [-4.899742, -46.016852],
  [-4.899865, -46.017030],
  [-4.899953, -46.017027],
  [-4.900074, -46.016978],
  [-4.900129, -46.016941],
  [-4.900213, -46.016876],
  [-4.900405, -46.016782],
  [-4.900561, -46.016693],
  [-4.900649, -46.016671],
  [-4.900824, -46.016667],
  [-4.900955, -46.016679],
  [-4.901192, -46.016810],
  [-4.901403, -46.017051],
  [-4.901470, -46.017127],
  [-4.901509, -46.017227],
  [-4.901490, -46.017468],
  [-4.901573, -46.017565],
  [-4.901635, -46.017561],
  [-4.901715, -46.017533],
  [-4.901768, -46.017427],
  [-4.901790, -46.017213],
  [-4.901785, -46.017079],
  [-4.901798, -46.017024],
  [-4.901822, -46.016981],
  [-4.901866, -46.016969],
  [-4.902004, -46.016972],
  [-4.902113, -46.017024],
  [-4.902171, -46.017082],
  [-4.902205, -46.017108],
  [-4.902185, -46.017215],
  [-4.902160, -46.017304],
  [-4.902115, -46.017510],
  [-4.902117, -46.017623],
  [-4.902171, -46.017720],
  [-4.902177, -46.017763],
  [-4.902191, -46.017814],
  [-4.902273, -46.017788],
  [-4.902328, -46.017698],
  [-4.902335, -46.017568],
  [-4.902327, -46.017431],
  [-4.902357, -46.017347],
  [-4.902423, -46.017378],
  [-4.902529, -46.017480],
  [-4.902603, -46.017510],
  [-4.902677, -46.017627],
  [-4.902711, -46.017779],
  [-4.902725, -46.017879],
  [-4.902756, -46.017947],
  [-4.902799, -46.017967],
  [-4.902891, -46.017937],
  [-4.902918, -46.017902],
  [-4.902937, -46.017838],
  [-4.902952, -46.017801],
  [-4.903052, -46.017784],
  [-4.903148, -46.017860],
  [-4.903242, -46.017981],
  [-4.903436, -46.018245],
  [-4.903551, -46.018264],
  [-4.903697, -46.018121],
  [-4.903769, -46.018096],
  [-4.903838, -46.018098],
  [-4.903917, -46.018114],
  [-4.903970, -46.018141],
  [-4.904019, -46.018184],
  [-4.904253, -46.018278],
  [-4.904510, -46.018248],
  [-4.904658, -46.018278],
  [-4.904797, -46.018350],
  [-4.905444, -46.018922],
  [-4.906075, -46.019458],
  [-4.906253, -46.019595],
  [-4.906394, -46.019655],
  [-4.906629, -46.019713],
  [-4.906792, -46.019719],
  [-4.906958, -46.019827],
  [-4.907084, -46.019885],
  [-4.907249, -46.019937],
  [-4.907441, -46.019960],
  [-4.907543, -46.019952],
  [-4.907582, -46.019966],
  [-4.907582, -46.019966],
  [-4.907720, -46.020004],
  [-4.907762, -46.019966],
  [-4.907748, -46.019898],
  [-4.907723, -46.019842],
  [-4.907695, -46.019701],
  [-4.907692, -46.019548],
  [-4.907700, -46.019522],
  [-4.907754, -46.019490],
  [-4.907828, -46.019487],
  [-4.907894, -46.019514],
  [-4.907921, -46.019544],
  [-4.908000, -46.019648],
  [-4.908047, -46.019717],
  [-4.908099, -46.019811],
  [-4.908192, -46.019937],
  [-4.908249, -46.019992],
  [-4.908334, -46.020047],
  [-4.908354, -46.020061],
  [-4.908405, -46.020070],
  [-4.908493, -46.020055],
  [-4.908531, -46.019958],
  [-4.908560, -46.019925],
  [-4.908605, -46.019888],
  [-4.908652, -46.019867],
  [-4.908695, -46.019867],
  [-4.908774, -46.019905],
  [-4.908833, -46.019912],
  [-4.908879, -46.019824],
  [-4.908907, -46.019808],
  [-4.908982, -46.019804],
  [-4.909025, -46.019813],
  [-4.909073, -46.019846],
  [-4.909111, -46.019922],
  [-4.909174, -46.019949],
  [-4.909293, -46.019929],
  [-4.909374, -46.019838],
  [-4.909424, -46.019726],
  [-4.909449, -46.019636],
  [-4.909495, -46.019629],
  [-4.909519, -46.019653],
  [-4.909534, -46.019680],
  [-4.909524, -46.019759],
  [-4.909492, -46.019818],
  [-4.909479, -46.019881],
  [-4.909497, -46.019911],
  [-4.909510, -46.019923],
  [-4.909556, -46.019916],
  [-4.909585, -46.019903],
  [-4.909613, -46.019868],
  [-4.909650, -46.019833],
  [-4.909669, -46.019830],
  [-4.909682, -46.019849],
  [-4.909655, -46.019898],
  [-4.909626, -46.019922],
  [-4.909598, -46.019973],
  [-4.909630, -46.020028],
  [-4.909672, -46.020080],
  [-4.909715, -46.020117],
  [-4.909715, -46.020136],
  [-4.909691, -46.020198],
  [-4.909617, -46.020470],
  [-4.909605, -46.020524],
  [-4.909609, -46.020580],
  [-4.909620, -46.020626],
  [-4.909640, -46.020673],
  [-4.909683, -46.020716],
  [-4.909805, -46.020787],
  [-4.909872, -46.020878],
  [-4.909875, -46.020942],
  [-4.909862, -46.020972],
  [-4.909886, -46.020994],
  [-4.909964, -46.020999],
  [-4.910002, -46.020908],
  [-4.910104, -46.020770],
  [-4.910160, -46.020731],
  [-4.910200, -46.020719],
  [-4.910248, -46.020725],
  [-4.910367, -46.020771],
  [-4.910401, -46.020805],
  [-4.910418, -46.020849],
  [-4.910389, -46.021044],
  [-4.910420, -46.021122],
  [-4.910436, -46.021205],
  [-4.910452, -46.021216],
  [-4.910539, -46.020997],
  [-4.910579, -46.020965],
  [-4.910697, -46.020939],
  [-4.910764, -46.020938],
  [-4.910858, -46.020943],
  [-4.910958, -46.020979],
  [-4.911028, -46.021038],
  [-4.911099, -46.021139],
  [-4.911121, -46.021204],
  [-4.911135, -46.021263],
  [-4.911140, -46.021321],
  [-4.911142, -46.021352],
  [-4.911157, -46.021377],
  [-4.911250, -46.021367],
  [-4.911353, -46.021376],
  [-4.911481, -46.021410],
  [-4.911621, -46.021398],
  [-4.911651, -46.021414],
  [-4.911671, -46.021449],
  [-4.911677, -46.021496],
  [-4.911672, -46.021566],
  [-4.911642, -46.021614],
  [-4.911636, -46.021659],
  [-4.911621, -46.021704],
  [-4.911564, -46.021792],
  [-4.911557, -46.021822],
  [-4.911516, -46.021872],
  [-4.911526, -46.021931],
  [-4.911511, -46.021970],
  [-4.911514, -46.021988],
  [-4.911532, -46.022004],
  [-4.911562, -46.022010],
  [-4.911605, -46.022001],
  [-4.911640, -46.021991],
  [-4.911652, -46.021997],
  [-4.911840, -46.022130],
  [-4.911871, -46.022174],
  [-4.911891, -46.022245],
  [-4.911900, -46.022340],
  [-4.911919, -46.022394],
  [-4.911964, -46.022452],
  [-4.912043, -46.022471],
  [-4.912515, -46.022560],
  [-4.912576, -46.022605],
  [-4.912604, -46.022684],
  [-4.912636, -46.022831],
  [-4.912729, -46.023099],
  [-4.912786, -46.023229],
  [-4.912843, -46.023405],
  [-4.912847, -46.023549],
  [-4.912850, -46.023653],
  [-4.912904, -46.023803],
  [-4.913028, -46.023911],
  [-4.913334, -46.024099],
  [-4.913368, -46.024116],
  [-4.913503, -46.024160],
  [-4.913663, -46.024230],
  [-4.913757, -46.024265],
  [-4.913822, -46.024284],
  [-4.913927, -46.024351],
  [-4.914065, -46.024475],
  [-4.914147, -46.024527],
  [-4.914240, -46.024577],
  [-4.914357, -46.024632],
  [-4.914486, -46.024669],
  [-4.914670, -46.024879],
  [-4.914807, -46.025056],
  [-4.914867, -46.025062],
  [-4.915002, -46.025039],
  [-4.915154, -46.025024],
  [-4.915218, -46.025059],
  [-4.915288, -46.025186],
  [-4.915345, -46.025253],
  [-4.915442, -46.025284],
  [-4.915632, -46.025346],
  [-4.915747, -46.025352],
  [-4.915846, -46.025367],
  [-4.915986, -46.025400],
  [-4.916131, -46.025465],
  [-4.916238, -46.025559],
  [-4.916325, -46.025670],
  [-4.916599, -46.025957],
  [-4.916640, -46.025998],
  [-4.916729, -46.026014],
  [-4.917073, -46.026087],
  [-4.917208, -46.026168],
  [-4.917386, -46.026224],
  [-4.917727, -46.026234],
  [-4.917838, -46.026259],
  [-4.917937, -46.026307],
  [-4.917990, -46.026340],
  [-4.918046, -46.026374],
  [-4.918131, -46.026476],
  [-4.918169, -46.026562],
  [-4.918185, -46.026620],
  [-4.918213, -46.026662],
  [-4.918293, -46.026712],
  [-4.918362, -46.026741],
  [-4.918433, -46.026783],
  [-4.918477, -46.026787],
  [-4.918572, -46.026808],
  [-4.918599, -46.026875],
  [-4.918667, -46.026957],
  [-4.918706, -46.026997],
  [-4.918778, -46.026956],
  [-4.918856, -46.026954],
  [-4.919154, -46.027196],
  [-4.919168, -46.027288],
  [-4.919167, -46.027360],
  [-4.919166, -46.027398],
  [-4.919226, -46.027443],
  [-4.919269, -46.027450],
  [-4.919318, -46.027448],
  [-4.919363, -46.027434],
  [-4.919519, -46.027391],
  [-4.919545, -46.027368],
  [-4.919557, -46.027335],
  [-4.919565, -46.027295],
  [-4.919589, -46.027229],
  [-4.919623, -46.027206],
  [-4.919677, -46.027201],
  [-4.919720, -46.027218],
  [-4.919768, -46.027255],
  [-4.919835, -46.027325],
  [-4.919934, -46.027400],
  [-4.919952, -46.027410],
  [-4.920206, -46.027553],
  [-4.920411, -46.027650],
  [-4.920557, -46.027784],
  [-4.920699, -46.027961],
  [-4.920701, -46.028023],
  [-4.920688, -46.028052],
  [-4.920659, -46.028074],
  [-4.920580, -46.028101],
  [-4.920433, -46.028146],
  [-4.920345, -46.028127],
  [-4.920230, -46.028129],
  [-4.920155, -46.028158],
  [-4.920137, -46.028170],
  [-4.920145, -46.028216],
  [-4.920264, -46.028375],
  [-4.920211, -46.028559],
  [-4.920249, -46.028772],
  [-4.920179, -46.029009],
  [-4.920164, -46.029192],
  [-4.920180, -46.029270],
  [-4.920281, -46.029313],
  [-4.920413, -46.029306],
  [-4.920424, -46.029285],
  [-4.920324, -46.029133],
  [-4.920319, -46.029091],
  [-4.920338, -46.029043],
  [-4.920496, -46.028949],
  [-4.920670, -46.028917],
  [-4.920831, -46.028922],
  [-4.920900, -46.028906],
  [-4.921136, -46.028889],
  [-4.921169, -46.028982],
  [-4.921171, -46.029035],
  [-4.921166, -46.029113],
  [-4.921170, -46.029141],
  [-4.921193, -46.029181],
  [-4.921222, -46.029209],
  [-4.921289, -46.029227],
  [-4.921398, -46.029235],
  [-4.921486, -46.029226],
  [-4.921539, -46.029164],
  [-4.921593, -46.029081],
  [-4.921625, -46.028998],
  [-4.921649, -46.028873],
  [-4.921675, -46.028838],
  [-4.921735, -46.028806],
  [-4.921775, -46.028794],
  [-4.921816, -46.028799],
  [-4.921859, -46.028813],
  [-4.921888, -46.028852],
  [-4.921896, -46.028900],
  [-4.921878, -46.028973],
  [-4.921845, -46.029062],
  [-4.921847, -46.029112],
  [-4.921873, -46.029163],
  [-4.921889, -46.029185],
  [-4.921936, -46.029220],
  [-4.921991, -46.029232],
  [-4.922046, -46.029223],
  [-4.922127, -46.029196],
  [-4.922184, -46.029161],
  [-4.922218, -46.029119],
  [-4.922246, -46.029108],
  [-4.922276, -46.029104],
  [-4.922354, -46.029127],
  [-4.922424, -46.029162],
  [-4.922495, -46.029207],
  [-4.922585, -46.029191],
  [-4.922702, -46.029151],
  [-4.922724, -46.029137],
  [-4.922792, -46.029100],
  [-4.922855, -46.029039],
  [-4.922900, -46.028982],
  [-4.922965, -46.028873],
  [-4.922996, -46.028811],
  [-4.922996, -46.028776],
  [-4.922989, -46.028761],
  [-4.922977, -46.028749],
  [-4.922892, -46.028734],
  [-4.922862, -46.028710],
  [-4.922841, -46.028653],
  [-4.922748, -46.028632],
  [-4.922505, -46.028653],
  [-4.922413, -46.028644],
  [-4.922347, -46.028617],
  [-4.922310, -46.028588],
  [-4.922242, -46.028492],
  [-4.922198, -46.028392],
  [-4.922188, -46.028301],
  [-4.922195, -46.028254],
  [-4.922208, -46.028221],
  [-4.922228, -46.028197],
  [-4.922254, -46.028176],
  [-4.922291, -46.028165],
  [-4.922319, -46.028160],
  [-4.922357, -46.028160],
  [-4.922428, -46.028183],
  [-4.922611, -46.028277],
  [-4.922665, -46.028303],
  [-4.922727, -46.028315],
  [-4.922800, -46.028311],
  [-4.922858, -46.028294],
  [-4.922881, -46.028275],
  [-4.922899, -46.028244],
  [-4.922903, -46.028207],
  [-4.922887, -46.028143],
  [-4.922883, -46.028107],
  [-4.922925, -46.028048],
  [-4.922943, -46.028016],
  [-4.922943, -46.027995],
  [-4.922923, -46.027962],
  [-4.922758, -46.027926],
  [-4.922730, -46.027880],
  [-4.922695, -46.027761],
  [-4.922697, -46.027576],
  [-4.922715, -46.027401],
  [-4.922734, -46.027318],
  [-4.922773, -46.027256],
  [-4.922823, -46.027206],
  [-4.922877, -46.027181],
  [-4.922941, -46.027161],
  [-4.923000, -46.027163],
  [-4.923431, -46.027190],
  [-4.923794, -46.027227],
  [-4.923960, -46.027211],
  [-4.924043, -46.027190],
  [-4.924225, -46.027072],
  [-4.925179, -46.026331],
  [-4.925216, -46.026314],
  [-4.925271, -46.026304],
  [-4.925428, -46.026306],
  [-4.926341, -46.026478],
  [-4.926596, -46.026427],
  [-4.926768, -46.026357],
  [-4.927250, -46.026122],
  [-4.927833, -46.025812],
  [-4.928482, -46.025239],
  [-4.928374, -46.024972],
  [-4.929476, -46.024556],
  [-4.930295, -46.024379],
  [-4.931075, -46.024336],
  [-4.931695, -46.024388],
  [-4.932372, -46.024506],
  [-4.933303, -46.024807],
  [-4.934555, -46.025515],
  [-4.935456, -46.026319],
  [-4.935825, -46.026755],
  [-4.938776, -46.030722],
  [-4.939125, -46.031313],
  [-4.941903, -46.036212],
  [-4.942952, -46.037547],
  [-4.943667, -46.038088],
  [-4.945333, -46.038895],
  [-4.951674, -46.040351],
  [-4.959145, -46.042067],
  [-4.962858, -46.042951],
  [-4.963576, -46.043246],
  [-4.964266, -46.043648],
  [-4.965309, -46.044549],
  [-4.966000, -46.045509],
  [-4.966415, -46.046425],
  [-4.966603, -46.047124],
  [-4.967095, -46.049954],
  [-4.967625, -46.051201],
  [-4.968892, -46.052807],
  [-4.969475, -46.053271],
  [-4.970460, -46.053854],
  [-4.976768, -46.057351],
  [-4.978084, -46.058303],
  [-4.981707, -46.061377],
  [-4.982993, -46.062288],
  [-4.989163, -46.065148],
  [-4.991675, -46.066283],
  [-4.999291, -46.069696],
  [-5.002452, -46.071116],
  [-5.003744, -46.071696],
  [-5.004771, -46.072335],
  [-5.005394, -46.072845],
  [-5.006480, -46.073963],
  [-5.022611, -46.090634],
  [-5.029145, -46.097382],
  [-5.032296, -46.100684],
  [-5.033579, -46.101620],
  [-5.034651, -46.102067],
  [-5.036128, -46.102431],
  [-5.038465, -46.102929],
  [-5.038812, -46.103071],
  [-5.040058, -46.103583],
  [-5.040811, -46.104168],
  [-5.044267, -46.108332],
  [-5.047509, -46.112283],
  [-5.047934, -46.113031],
  [-5.048947, -46.115623],
  [-5.049323, -46.116362],
  [-5.050960, -46.118431],
  [-5.051336, -46.119083],
  [-5.053341, -46.124723],
  [-5.056145, -46.132758],
  [-5.056360, -46.133699],
  [-5.056504, -46.134861],
  [-5.056514, -46.138262],
  [-5.056778, -46.140389],
  [-5.056861, -46.141147],
  [-5.056739, -46.146317],
  [-5.056365, -46.148845],
  [-5.056211, -46.166233],
  [-5.056368, -46.167227],
  [-5.056965, -46.168716],
  [-5.059173, -46.171803],
  [-5.061245, -46.174549],
  [-5.062837, -46.176127],
  [-5.068139, -46.180332],
  [-5.069121, -46.181480],
  [-5.069607, -46.182466],
  [-5.070917, -46.186100],
  [-5.071785, -46.187407],
  [-5.073296, -46.188634],
  [-5.075189, -46.189408],
  [-5.080413, -46.190144],
  [-5.081796, -46.190500],
  [-5.089011, -46.192864],
  [-5.092392, -46.194097],
  [-5.094379, -46.195232],
  [-5.100840, -46.199073],
  [-5.102083, -46.199545],
  [-5.103035, -46.199713],
  [-5.109233, -46.199848],
  [-5.110957, -46.200247],
  [-5.112358, -46.201013],
  [-5.117556, -46.204740],
  [-5.122355, -46.208209],
  [-5.125908, -46.210767],
  [-5.132455, -46.215483],
  [-5.133983, -46.216326],
  [-5.135501, -46.216693],
  [-5.137164, -46.216773],
  [-5.141821, -46.215279],
  [-5.147068, -46.213708],
  [-5.148400, -46.213490],
  [-5.150099, -46.213449],
  [-5.156664, -46.213338],
  [-5.163422, -46.213260],
  [-5.164760, -46.213434],
  [-5.172378, -46.215404],
  [-5.177189, -46.216755],
  [-5.183828, -46.217909],
  [-5.189472, -46.218746],
  [-5.190385, -46.218780],
  [-5.191704, -46.218586],
  [-5.191632, -46.218231],
  [-5.189826, -46.207109],
  [-5.188332, -46.197932],
  [-5.197361, -46.193157],
  [-5.212710, -46.184881],
  [-5.220972, -46.180327],
  [-5.237070, -46.171568],
  [-5.240524, -46.175122],
  [-5.247165, -46.181613],
  [-5.248289, -46.184637],
  [-5.251162, -46.192863],
  [-5.251274, -46.193206],
  [-5.252512, -46.192816],
  [-5.255877, -46.190946],
  [-5.257145, -46.190740],
  [-5.258888, -46.190980],
  [-5.259902, -46.190943],
  [-5.260491, -46.190765],
  [-5.263971, -46.188875],
  [-5.268239, -46.187306],
  [-5.269378, -46.187091],
  [-5.270540, -46.187093],
  [-5.271830, -46.187395],
  [-5.272634, -46.187741],
  [-5.274040, -46.188758],
  [-5.274639, -46.189426],
  [-5.275579, -46.190845],
  [-5.276746, -46.192704],
  [-5.277627, -46.193837],
  [-5.278719, -46.194717],
  [-5.280073, -46.195381],
  [-5.281244, -46.195663],
  [-5.285166, -46.195626],
  [-5.290065, -46.195578],
  [-5.299027, -46.195450],
  [-5.300106, -46.195642],
  [-5.303422, -46.196362],
  [-5.307328, -46.197551],
  [-5.309675, -46.198536],
  [-5.311693, -46.199385],
  [-5.312577, -46.199678],
  [-5.315328, -46.200309],
  [-5.316649, -46.200612],
  [-5.318290, -46.201143],
  [-5.323314, -46.203667],
  [-5.329376, -46.206682],
  [-5.330728, -46.207029],
  [-5.332564, -46.206972],
  [-5.340802, -46.204898],
  [-5.348460, -46.203109],
  [-5.349247, -46.203134],
  [-5.351108, -46.203610],
  [-5.351447, -46.206853],
  [-5.352205, -46.214094],
  [-5.352871, -46.220649],
  [-5.353794, -46.229565],
  [-5.354753, -46.238647],
  [-5.355341, -46.244510],
  [-5.355806, -46.248977],
  [-5.356765, -46.258234],
  [-5.357537, -46.265968],
  [-5.358469, -46.275123],
  [-5.359110, -46.281769],
  [-5.359430, -46.284613],
  [-5.360399, -46.294189],
  [-5.361431, -46.304663],
  [-5.362331, -46.313419],
  [-5.363035, -46.320482],
  [-5.363997, -46.329969],
  [-5.364244, -46.332525],
  [-5.365122, -46.341368],
  [-5.365721, -46.347348],
  [-5.366593, -46.356252],
  [-5.367648, -46.366666],
  [-5.369189, -46.377817],
  [-5.369182, -46.382570],
  [-5.369646, -46.387223],
  [-5.370680, -46.397561],
  [-5.371770, -46.408474],
  [-5.372654, -46.417514],
  [-5.373489, -46.426449],
  [-5.374410, -46.435965],
  [-5.375312, -46.445312],
  [-5.376121, -46.453688],
  [-5.376508, -46.458400],
  [-5.376860, -46.461546],
  [-5.376931, -46.462289],
  [-5.377841, -46.471726],
  [-5.378502, -46.478615],
  [-5.378759, -46.481274],
  [-5.379653, -46.490622],
  [-5.380537, -46.500100],
  [-5.380738, -46.502300],
  [-5.381536, -46.511083],
  [-5.382370, -46.519959],
  [-5.383345, -46.529518],
  [-5.384177, -46.538119],
  [-5.385113, -46.547099],
  [-5.385988, -46.556960],
  [-5.386863, -46.565667],
  [-5.387710, -46.574806],
  [-5.388667, -46.584998],
  [-5.389408, -46.592363],
  [-5.388086, -46.592967],
  [-5.386492, -46.591744],
  [-5.385410, -46.591594],
  [-5.384266, -46.591500],
  [-5.382945, -46.591650],
  [-5.382158, -46.592110],
  [-5.381067, -46.593111],
  [-5.379930, -46.593294],
  [-5.378704, -46.593815],
  [-5.377710, -46.594743],
  [-5.376103, -46.596491],
  [-5.375025, -46.597916],
  [-5.374257, -46.599003],
  [-5.374284, -46.600222],
  [-5.373914, -46.601814],
  [-5.374151, -46.603187],
  [-5.373551, -46.605127],
  [-5.373429, -46.606814],
  [-5.373673, -46.607610],
  [-5.373026, -46.608154],
  [-5.371527, -46.608998],
  [-5.370740, -46.609850],
  [-5.369793, -46.610769],
  [-5.368603, -46.610225],
  [-5.367609, -46.610469],
  [-5.367122, -46.612025],
  [-5.366597, -46.612775],
  [-5.365528, -46.613328],
  [-5.364685, -46.614415],
  [-5.363654, -46.615390],
  [-5.362735, -46.616767],
  [-5.361711, -46.617134],
  [-5.361751, -46.618482],
  [-5.360953, -46.618703],
  [-5.360224, -46.619654],
  [-5.359877, -46.620526],
  [-5.359736, -46.621772],
  [-5.360012, -46.622362],
  [-5.360111, -46.623909],
  [-5.360486, -46.625071],
  [-5.360252, -46.626515],
  [-5.359914, -46.627639],
  [-5.360196, -46.628417],
  [-5.359737, -46.630126],
  [-5.359957, -46.630599],
  [-5.360872, -46.631984],
  [-5.360835, -46.632374],
  [-5.360600, -46.632688],
  [-5.360038, -46.633106],
  [-5.359422, -46.634547],
  [-5.358242, -46.635583],
  [-5.358223, -46.636515],
  [-5.358110, -46.637602],
  [-5.357476, -46.638565],
  [-5.356423, -46.639656],
  [-5.355953, -46.641029],
  [-5.355577, -46.641837],
  [-5.355012, -46.642684],
  [-5.354279, -46.643831],
  [-5.353122, -46.644010],
  [-5.351787, -46.643652],
  [-5.349737, -46.642439],
  [-5.348758, -46.641549],
  [-5.347555, -46.641574],
  [-5.346876, -46.642412],
  [-5.346021, -46.643515],
  [-5.345608, -46.644593],
  [-5.344762, -46.645665],
  [-5.344424, -46.646379],
  [-5.343659, -46.647246],
  [-5.343478, -46.647953],
  [-5.343190, -46.648607],
  [-5.342745, -46.649403],
  [-5.341831, -46.649470],
  [-5.340864, -46.650175],
  [-5.340289, -46.651090],
  [-5.340027, -46.652005],
  [-5.340394, -46.653145],
  [-5.340262, -46.654462],
  [-5.339087, -46.654895],
  [-5.337827, -46.655083],
  [-5.336492, -46.656032],
  [-5.335664, -46.656710],
  [-5.334799, -46.656973],
  [-5.333990, -46.656258],
  [-5.332880, -46.655703],
  [-5.331545, -46.655713],
  [-5.331047, -46.656239],
  [-5.330454, -46.656738],
  [-5.330257, -46.657716],
  [-5.330426, -46.658224],
  [-5.330605, -46.659714],
  [-5.330407, -46.661549],
  [-5.329810, -46.662258],
  [-5.329396, -46.663273],
  [-5.329199, -46.664129],
  [-5.328625, -46.665004],
  [-5.328089, -46.665953],
  [-5.327882, -46.667195],
  [-5.328353, -46.668239],
  [-5.328390, -46.668840],
  [-5.327911, -46.669386],
  [-5.328183, -46.670289],
  [-5.328211, -46.671502],
  [-5.327986, -46.672912],
  [-5.328070, -46.673730],
  [-5.327339, -46.674047],
  [-5.326500, -46.674229],
  [-5.325860, -46.675019],
  [-5.326208, -46.675799],
  [-5.326585, -46.676575],
  [-5.326304, -46.677348],
  [-5.326140, -46.678512],
  [-5.325180, -46.678903],
  [-5.324226, -46.679191],
  [-5.323402, -46.679505],
  [-5.322945, -46.679688],
  [-5.322211, -46.680020],
  [-5.322043, -46.680511],
  [-5.321808, -46.681700],
  [-5.321664, -46.683035],
  [-5.322341, -46.683750],
  [-5.322322, -46.685311],
  [-5.323225, -46.685998],
  [-5.323658, -46.686778],
  [-5.323244, -46.688292],
  [-5.322557, -46.688960],
  [-5.321617, -46.690032],
  [-5.320630, -46.690323],
  [-5.319369, -46.690145],
  [-5.318305, -46.689817],
  [-5.317625, -46.690117],
  [-5.317207, -46.690496],
  [-5.317024, -46.690902],
  [-5.317194, -46.691647],
  [-5.317325, -46.691908],
  [-5.318315, -46.693221],
  [-5.318894, -46.693981],
  [-5.320169, -46.695364],
  [-5.319962, -46.696690],
  [-5.319576, -46.697461],
  [-5.318871, -46.697922],
  [-5.317874, -46.698495],
  [-5.316978, -46.699417],
  [-5.317031, -46.699874],
  [-5.316680, -46.700583],
  [-5.316765, -46.701664],
  [-5.316379, -46.702445],
  [-5.315358, -46.703076],
  [-5.313449, -46.703926],
  [-5.311539, -46.704817],
  [-5.310464, -46.704787],
  [-5.309947, -46.705464],
  [-5.309748, -46.706132],
  [-5.309599, -46.706620],
  [-5.309740, -46.707147],
  [-5.309505, -46.708482],
  [-5.309547, -46.709058],
  [-5.309608, -46.709291],
  [-5.309801, -46.709909],
  [-5.310140, -46.710680],
  [-5.309947, -46.711049],
  [-5.309894, -46.711755],
  [-5.310046, -46.712937],
  [-5.309933, -46.714291],
  [-5.309820, -46.715834],
  [-5.309557, -46.716323],
  [-5.309091, -46.716519],
  [-5.308503, -46.716680],
  [-5.308249, -46.717461],
  [-5.307215, -46.717912],
  [-5.306510, -46.718081],
  [-5.305902, -46.718061],
  [-5.304808, -46.718006],
  [-5.303510, -46.717724],
  [-5.302635, -46.718307],
  [-5.301958, -46.719106],
  [-5.301225, -46.719783],
  [-5.300922, -46.720754],
  [-5.300595, -46.721263],
  [-5.300425, -46.721760],
  [-5.300308, -46.722322],
  [-5.300183, -46.723054],
  [-5.300066, -46.723786],
  [-5.299942, -46.724413],
  [-5.299824, -46.725472],
  [-5.299667, -46.725799],
  [-5.299238, -46.726202],
  [-5.299344, -46.727248],
  [-5.298526, -46.727539],
  [-5.297012, -46.727144],
  [-5.295188, -46.726918],
  [-5.294266, -46.727501],
  [-5.293758, -46.728160],
  [-5.292686, -46.729062],
  [-5.292160, -46.729608],
  [-5.291238, -46.730097],
  [-5.290392, -46.730097],
  [-5.289056, -46.730153],
  [-5.287796, -46.729589],
  [-5.287270, -46.728912],
  [-5.286310, -46.728630],
  [-5.285215, -46.728386],
  [-5.284499, -46.728295],
  [-5.283546, -46.727642],
  [-5.282774, -46.727367],
  [-5.282264, -46.727485],
  [-5.281702, -46.727694],
  [-5.280905, -46.728151],
  [-5.279493, -46.728922],
  [-5.278905, -46.729248],
  [-5.278674, -46.730022],
  [-5.277612, -46.730943],
  [-5.275938, -46.732185],
  [-5.274753, -46.732824],
  [-5.273625, -46.733614],
  [-5.272176, -46.733482],
  [-5.271161, -46.733840],
  [-5.270615, -46.734009],
  [-5.269863, -46.734291],
  [-5.269619, -46.734648],
  [-5.268998, -46.734874],
  [-5.268387, -46.736755],
  [-5.266976, -46.736435],
  [-5.265566, -46.736341],
  [-5.264117, -46.737112],
  [-5.262951, -46.737357],
  [-5.261766, -46.737018],
  [-5.260431, -46.736586],
  [-5.259340, -46.736868],
  [-5.258061, -46.737319],
  [-5.256989, -46.737526],
  [-5.255353, -46.737526],
  [-5.254525, -46.737785],
  [-5.254478, -46.738494],
  [-5.254464, -46.739110],
  [-5.254488, -46.739510],
  [-5.254556, -46.740006],
  [-5.254257, -46.740737],
  [-5.253881, -46.741250],
  [-5.253863, -46.742228],
  [-5.253432, -46.742515],
  [-5.252936, -46.742374],
  [-5.252504, -46.742737],
  [-5.251784, -46.742416],
  [-5.250665, -46.742397],
  [-5.250176, -46.742181],
  [-5.249584, -46.742482],
  [-5.248709, -46.742369],
  [-5.248173, -46.742707],
  [-5.247759, -46.743074],
  [-5.247064, -46.743544],
  [-5.246161, -46.743620],
  [-5.245465, -46.744579],
  [-5.245411, -46.745254],
  [-5.244757, -46.745699],
  [-5.243616, -46.745456],
  [-5.242636, -46.745783],
  [-5.241551, -46.745887],
  [-5.240702, -46.745913],
  [-5.239917, -46.745848],
  [-5.238937, -46.745561],
  [-5.237892, -46.745521],
  [-5.236924, -46.745665],
  [-5.236140, -46.745913],
  [-5.235251, -46.746292],
  [-5.234912, -46.746436],
  [-5.233840, -46.747103],
  [-5.232768, -46.748044],
  [-5.231434, -46.748905],
  [-5.230193, -46.748905],
  [-5.229403, -46.748453],
  [-5.228670, -46.749017],
  [-5.228275, -46.749751],
  [-5.227861, -46.749995],
  [-5.227240, -46.750108],
  [-5.227203, -46.750635],
  [-5.227050, -46.751207],
  [-5.226508, -46.751625],
  [-5.226102, -46.752200],
  [-5.225878, -46.752905],
  [-5.225821, -46.753082],
  [-5.225376, -46.753676],
  [-5.225096, -46.754829],
  [-5.224476, -46.755487],
  [-5.224438, -46.756051],
  [-5.223534, -46.756213],
  [-5.223181, -46.756539],
  [-5.222858, -46.757123],
  [-5.222501, -46.757462],
  [-5.221636, -46.757744],
  [-5.220785, -46.757396],
  [-5.219637, -46.756945],
  [-5.218452, -46.757321],
  [-5.216995, -46.756681],
  [-5.216130, -46.756945],
  [-5.215067, -46.756475],
  [-5.213929, -46.756634],
  [-5.212773, -46.756343],
  [-5.211889, -46.757293],
  [-5.211315, -46.757142],
  [-5.209989, -46.757217],
  [-5.209161, -46.757189],
  [-5.208259, -46.757481],
  [-5.207967, -46.758083],
  [-5.207506, -46.758139],
  [-5.207250, -46.758374],
  [-5.202731, -46.766300],
  [-5.198309, -46.774057],
  [-5.193818, -46.781936],
  [-5.189309, -46.789858],
  [-5.184854, -46.797684],
  [-5.182814, -46.801224],
  [-5.174430, -46.797808],
  [-5.166304, -46.794499],
  [-5.157424, -46.790896],
  [-5.149584, -46.787715],
  [-5.140721, -46.784101],
  [-5.132584, -46.780783],
  [-5.128876, -46.779278],
  [-5.121642, -46.776321],
  [-5.113128, -46.772848],
  [-5.105061, -46.769533],
  [-5.097277, -46.766344],
  [-5.089895, -46.763306],
  [-5.081064, -46.759672],
  [-5.072068, -46.755956],
  [-5.063078, -46.752248],
  [-5.054421, -46.748684],
  [-5.045930, -46.745195],
  [-5.037701, -46.741798],
  [-5.027782, -46.737755],
  [-5.019416, -46.734311],
  [-5.014073, -46.732198],
  [-5.010508, -46.730670],
  [-5.002146, -46.727231],
  [-4.993783, -46.723793],
  [-4.991328, -46.722783],
  [-4.982956, -46.719316],
  [-4.977317, -46.717066],
  [-4.968557, -46.713438],
  [-4.959824, -46.709847],
  [-4.950666, -46.706076],
  [-4.941514, -46.702308],
  [-4.932753, -46.698713],
  [-4.924065, -46.695136],
  [-4.915700, -46.691713],
  [-4.907333, -46.688301],
  [-4.899858, -46.685287],
  [-4.891498, -46.681849],
  [-4.883132, -46.678407],
  [-4.875292, -46.675196],
  [-4.866863, -46.671726],
  [-4.859405, -46.668656],
  [-4.854503, -46.666633],
  [-4.846577, -46.663362],
  [-4.837036, -46.659405],
  [-4.828456, -46.655875],
  [-4.819004, -46.651959],
  [-4.809911, -46.648215],
  [-4.800783, -46.644482],
  [-4.791549, -46.640660],
  [-4.783123, -46.637174],
  [-4.782377, -46.637071],
  [-4.782666, -46.636398],
  [-4.782747, -46.635498],
  [-4.782863, -46.635030],
  [-4.782984, -46.634298],
  [-4.782984, -46.633208],
  [-4.782936, -46.632259],
  [-4.782590, -46.631165],
  [-4.782325, -46.630112],
  [-4.782333, -46.629154],
  [-4.782236, -46.628423],
  [-4.782349, -46.627626],
  [-4.783716, -46.626854],
  [-4.784536, -46.626219],
  [-4.785268, -46.625648],
  [-4.786000, -46.625286],
  [-4.786692, -46.624538],
  [-4.787174, -46.623758],
  [-4.788582, -46.622181],
  [-4.789450, -46.621667],
  [-4.790094, -46.621072],
  [-4.790882, -46.620122],
  [-4.791928, -46.619753],
  [-4.792941, -46.619190],
  [-4.793826, -46.618128],
  [-4.794533, -46.617694],
  [-4.795161, -46.616616],
  [-4.796319, -46.616246],
  [-4.796978, -46.615554],
  [-4.797751, -46.614645],
  [-4.798209, -46.614002],
  [-4.798772, -46.613359],
  [-4.798699, -46.612664],
  [-4.798571, -46.611935],
  [-4.798784, -46.611223],
  [-4.798804, -46.610343],
  [-4.798949, -46.609578],
  [-4.798627, -46.608734],
  [-4.798056, -46.608444],
  [-4.798111, -46.606783],
  [-4.798006, -46.605071],
  [-4.797888, -46.604077],
  [-4.797758, -46.603568],
  [-4.798189, -46.602975],
  [-4.798507, -46.601861],
  [-4.798466, -46.600816],
  [-4.798724, -46.600012],
  [-4.799254, -46.599481],
  [-4.799351, -46.598725],
  [-4.798876, -46.597627],
  [-4.799616, -46.596799],
  [-4.799962, -46.595439],
  [-4.800517, -46.594635],
  [-4.800823, -46.593791],
  [-4.800984, -46.592785],
  [-4.800791, -46.591595],
  [-4.800557, -46.590847],
  [-4.800252, -46.590348],
  [-4.799978, -46.589850],
  [-4.799898, -46.589303],
  [-4.799705, -46.588740],
  [-4.799190, -46.588322],
  [-4.798732, -46.588225],
  [-4.798096, -46.587574],
  [-4.797759, -46.586922],
  [-4.797155, -46.586359],
  [-4.796721, -46.585877],
  [-4.796142, -46.585748],
  [-4.795949, -46.584976],
  [-4.796078, -46.584365],
  [-4.796094, -46.583625],
  [-4.796351, -46.582965],
  [-4.796190, -46.582290],
  [-4.796480, -46.581984],
  [-4.796994, -46.581727],
  [-4.797316, -46.580906],
  [-4.796673, -46.580185],
  [-4.795909, -46.580062],
  [-4.795563, -46.579394],
  [-4.795362, -46.578702],
  [-4.794960, -46.578043],
  [-4.794558, -46.577086],
  [-4.794204, -46.576394],
  [-4.794340, -46.575686],
  [-4.794823, -46.575244],
  [-4.794847, -46.574440],
  [-4.794453, -46.573837],
  [-4.795494, -46.572347],
  [-4.795669, -46.571854],
  [-4.795687, -46.570712],
  [-4.795841, -46.565339],
  [-4.796044, -46.558272],
  [-4.796318, -46.549368],
  [-4.796572, -46.539778],
  [-4.796901, -46.529483],
  [-4.797120, -46.520262],
  [-4.797311, -46.514618],
  [-4.797506, -46.506153],
  [-4.797555, -46.504063],
  [-4.797799, -46.495557],
  [-4.798050, -46.484725],
  [-4.798240, -46.476263],
  [-4.798454, -46.467325],
  [-4.798667, -46.458121],
  [-4.798704, -46.456209],
  [-4.798877, -46.449437],
  [-4.799075, -46.440832],
  [-4.799269, -46.431527],
  [-4.799493, -46.422533],
  [-4.799673, -46.415926],
  [-4.799850, -46.406898],
  [-4.800058, -46.397872],
  [-4.800230, -46.389364],
  [-4.800377, -46.382884],
  [-4.800408, -46.380972],
  [-4.800586, -46.370128],
  [-4.800832, -46.360899],
  [-4.800977, -46.351899],
  [-4.801191, -46.343540],
  [-4.801382, -46.334847],
  [-4.801518, -46.328736],
  [-4.801605, -46.324857],
  [-4.801828, -46.315452],
  [-4.802050, -46.306015],
  [-4.802269, -46.296979],
  [-4.802486, -46.287958],
  [-4.802703, -46.279035],
  [-4.802922, -46.270025],
  [-4.803110, -46.262041],
  [-4.803329, -46.252969],
  [-4.803552, -46.243586],
  [-4.803774, -46.234275],
  [-4.803993, -46.224951],
  [-4.804204, -46.215931],
  [-4.804435, -46.205851],
  [-4.804657, -46.195658],
  [-4.804805, -46.188034],
  [-4.804996, -46.179021],
  [-4.805304, -46.161857],
  [-4.805478, -46.152393],
  [-4.805620, -46.143212],
  [-4.805756, -46.134596],
  [-4.805876, -46.125558],
  [-4.806068, -46.123624],
  [-4.806013, -46.119616],
  [-4.806065, -46.110816],
  [-4.806260, -46.098780],
  [-4.806338, -46.089523],
  [-4.806418, -46.084242],
  [-4.806554, -46.075229],
  [-4.806603, -46.071165],
  [-4.806711, -46.062044],
  [-4.806818, -46.053031],
  [-4.806937, -46.044106],
  [-4.807077, -46.035114],
  [-4.807123, -46.033162],
  [-4.807123, -46.033162],
];

export const ARARIBOIA_CENTER: [number, number] = [-4.914273, -46.118593];
